import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ViewRef, ViewChildren, QueryList, } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, Params } from '@angular/router';
import { LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OverlayPanel } from 'primeng/overlaypanel';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { SearchRequestModel } from 'src/app/shared/models/request/search-request-model';
import { SalesOrderSummaryResponseModel } from 'src/app/shared/models/response/appointment/salesorder-summary-response-model';
import { PagedResponseModel } from 'src/app/shared/models/response/paged-response-model';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { AppointmentService } from '../../servicies/appointment.service';
import { AdminSettingsService } from '../../servicies/admin-settings.service';
import { WIPStatesResponseModel } from 'src/app/shared/models/response/appointment/wip-states-response-model';
import { SalesOrderCountsResponseModel } from 'src/app/shared/models/response/appointment/salesorder-counts-response-model';
import { DynamicCols } from 'src/app/shared/models/common/dynamic-cols';
import { SalesorderCallLogsComponent } from '../salesorder-call-logs/salesorder-call-logs.component';
import { SalesOrdersCountModel } from 'src/app/shared/models/response/appointment/salesorder-counts-model';
import { AppointmentSummaryResponseModel } from 'src/app/shared/models/response/appointment/appointment-summary-response-model'
import { AppointmentsCountsResponseModel } from 'src/app/shared/models/response/appointment/appointments-counts-response-model'
import { AppointmentCallResponseModel } from 'src/app/shared/models/request/call-request-model'
import { AppointmentUpdateStatusRequestModel } from 'src/app/shared/models/response/appointment/appointment-updatestatus-request-model';
import { CallConfigModel } from 'src/app/shared/models/response/call-config-model';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { QuickFilters } from 'src/app/shared/models/common/custom-filiters';
import { AppointmentCallListResponseModel } from 'src/app/shared/models/request/appointment-call-response-model';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
declare const Twilio: any;
import moment from "moment";
import { Table, TableHeaderCheckbox } from "primeng/table";
import { AppointmentCancelRequest } from 'src/app/shared/models/request/appointment-cancel-request';
import { GlobalSearchService } from '../../servicies/globalSearch.service';
import { TwillioCallService } from '../../servicies/twillioCall.service';
import { GlobalSearchModel } from 'src/app/shared/models/common/global.search'
import { SalesOrderInfoResponseModel } from 'src/app/shared/models/response/appointment/sales-order-info-reponse-model';
import { PatientInfoResponseModel } from 'src/app/shared/models/response/appointment/patient-info-response-model';
import { DoctorSummaryResponseModel } from 'src/app/shared/models/response/appointment/doctor-summary-response-model';
import { SalesOrderItemInfoResponseModel } from 'src/app/shared/models/response/appointment/salesorder-item-info-response-model'
import { BranchResponseModel } from 'src/app/shared/models/response/branch-response-model';
import { AdminUserService } from 'src/app/admin/servicies/admin-user.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { DateFormatModel } from 'src/app/shared/models/common/date-format-model'
import { AppointmentInfoReponseModel } from 'src/app/shared/models/response/appointment/appointment-info-reponse-model'
import { AppointmentDetailResponseModel } from 'src/app/shared/models/response/appointment/appointment-detail-response-model';
import { FacilityInfoResponseModel } from 'src/app/shared/models/response/facility/facilityinfo-response-model';
import { FacilitySearchRequestModel } from 'src/app/shared/models/request/facility-search-request';
import { TwilioDeviceObject } from 'src/app/shared/models/common/twilio-device-object';
import { FeatureGroupResponseModel, featureResponseModel } from 'src/app/shared/models/response/feature-group-response';

import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { Constants } from 'src/app/shared/constants';
import { CustomValidator } from 'src/app/shared/custom-validator';
import { WipStatusBTmapping } from 'src/app/shared/models/common/wip-status';
import { BTSalesOrderUpdateRequestModel } from 'src/app/shared/models/request/salesorder-update-request-model-brightree';
import { BookAppointmentInfoComponent } from '../../book-appointment-info/book-appointment-info.component';
import { CancelVoidResponseModel } from 'src/app/shared/models/response/settings/settings-classificationtype-response-model';
import { RCMCofigurationUrl } from 'src/app/shared/models/response/settings/settings-plugin-response-model';
import { DoctorResponseModel } from 'src/app/shared/models/response/doctor-response-model';
import { FacilityResponseModelDropdownList } from 'src/app/shared/models/response/facility/facility-response-model';
import { TimeZoneAvailableResponseModel } from 'src/app/shared/models/response/time-zone-available-response-model';
import { PrimaryInsuranceProviderResponseModel } from 'src/app/shared/models/response/appointment/primary-insurance-providers-response-model';
import { ModuleType } from 'src/app/shared/enums';
import { UserPreferencesModuleColumnResponseModel } from 'src/app/shared/models/response/user-wise-grid-column-response-model';
import { UserWiseModuleColumn } from 'src/app/shared/models/request/user-wise-column-model-request';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FilterClassificationTypeResponseModel } from 'src/app/shared/models/response/appointment/filter-classification-response-model';
import { UpdateStatusOfAppointmentComponent } from 'src/app/shared/components/update-status-of-appointment/update-status-of-appointment.component';
import { WipStatusBtService } from 'src/app/services/wip-status-bt.service';

export class statusInfo { action: string; reasonComment: string; reason: string; isBrightreeSystemAppUpdate: boolean };

@Component({
    selector: 'app-appointment-noshow',
    templateUrl: './appointment-noshow.component.html',
    styleUrls: ['./appointment-noshow.component.sass'],
    providers: [DialogService],
    standalone: false
})
export class AppointmentNoshowComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();
  private hasPageHistory: boolean = false;
  patientBrighttreeURL: any;
  salesOrderBrighttreeURL: any;
  facilityVisitTypes: SelectItem[];
  facilityVisitSelectedType: string;
  appointmentsalesOrderStatusMenuitems: MenuItem[];
  isDisabled: boolean = true;
  features: featureResponseModel[];
  //Not Scheduled
  isLockedAppointments: boolean = false;
  //selectedStatus: WIPStatesResponseModel;
  totalRecords: number;
  selectedsalesOrdersCount: number;
  totalPages: number;
  searchRequestModel: SearchRequestModel;
  salesOrders: SalesOrderSummaryResponseModel[];
  selectedsalesOrders: SalesOrderSummaryResponseModel[];
  salesOrderStatus: WIPStatesResponseModel[];
  salesOrderCountsResponseModel: SalesOrderCountsResponseModel;
  voidReasonsResponseModel: CancelVoidResponseModel[];
  reasonsResponseModel: CancelVoidResponseModel[];
  salesOrderCountModels: SalesOrdersCountModel[];
  salesSelectedOrderCountModels: SalesOrdersCountModel;
  appointmentCallListRequestModel: AppointmentCallListResponseModel[];
  wipStatusBTMappingResponseModel: WipStatusBTmapping[];
  dynamicNonSColumns: DynamicCols[];
  selectedNonSColumns: DynamicCols[];
  selectedSalesOrder: SalesOrderSummaryResponseModel;
  selectedTab: string;
  brightreeInternalUserId: number;
  duration: string;
  @ViewChild('searchBox', { static: false }) searchBox: ElementRef;
  @ViewChild('statusDropdown', { static: false }) statusDropdown: ElementRef;
  salesOrderType: string;
  AppointmentOrderType: string;
  callConfigModel: CallConfigModel;
  callPopup: boolean = false;
  callnote: string;
  calldate: Date;
  calltime: Date;
  callId: number;
  reschedulecallId: number;
  SchedulePopup: boolean = false;
  //Scheduled
  totalAppointmentRecords: number;
  totalAppointmentPages: number;
  appointmentsalesOrderStatus: WIPStatesResponseModel[];
  appointments: AppointmentSummaryResponseModel[];
  selectedAppointments: AppointmentSummaryResponseModel[];
  selectedAppointment: AppointmentSummaryResponseModel;
  appointment: AppointmentInfoReponseModel;
  appointmentsCounts: AppointmentsCountsResponseModel;
  selectedAppointmentStatus: WIPStatesResponseModel;
  dynamicColumns: DynamicCols[];
  selectedColumns: DynamicCols[];
  branchResponseModel: BranchResponseModel[];
  selectedNSbranch: BranchResponseModel;
  doctorResponseModel: DoctorResponseModel[];
  selectedDoctorResponseModel: DoctorResponseModel;
  facilityResponseModelDropdownList: FacilityResponseModelDropdownList[];
  selectedfacilityResponseModel: FacilityResponseModelDropdownList;
  selectedTimeZone: TimeZoneAvailableResponseModel[];
  selectedSbranch: BranchResponseModel;
  appointmentCountModels: SalesOrdersCountModel[];
  appointmentSelectedCountModels: SalesOrdersCountModel;
  timeZoneList: TimeZoneAvailableResponseModel[];
  filterClassificationList: FilterClassificationTypeResponseModel[];
  selectedClassificationType: FilterClassificationTypeResponseModel[];
  data1: any;
  dataExpressionloading: boolean = false;
  appDateFormat: DateFormatModel;
  @ViewChild("table", { static: false }) private _table: Table;
  @ViewChild('searchBoxAppointment', { static: false }) searchBoxAppointment: ElementRef;
  @ViewChild('statusDropdownAppointment', { static: false }) statusDropdownAppointment: ElementRef;
  @ViewChild("headerCheckBox", { static: false }) private headerCheckBox: TableHeaderCheckbox;

  @ViewChildren('headerCheckBox') childrenComponent: QueryList<TableHeaderCheckbox>;

  index: number = 0;
  connection: any;
  callSID: string;
  device: any;
  mySubscription: any;

  minutes: SelectItem[];
  selectedMinute: SelectItem;

  rescheduleCallSID: string;
  isAppointmentDisabled: boolean = false;
  selectedNSFilter: QuickFilters;
  quickNSFilters: QuickFilters[];
  selectedSFilter: QuickFilters;
  quickSFilters: QuickFilters[];
  searchFromNSDate: Date;
  searchToNSDate: Date;
  searchFromSDate: Date;
  searchToSDate: Date;
  customSDate: boolean;
  customNSDate: boolean;
  NsheduledTableDefaltColumns: number = 6;
  sheduledTableDefaltColumns: number = 6;
  scheduleappointment: boolean = true;
  schedulecall: boolean = false;
  actionType: string = "S";
  scheduleAction: string;
  loggedInUserId: number;
  selectedAppointmentType: string = "FacilityVisit";
  appointmentCallResponseModel: AppointmentCallResponseModel;
  // selectedfilterIndex = -1;
  // selectedfilterSIndex = -1;
  selectedfilterIndex = 0;
  selectedfilterSIndex = 1;
  status: boolean = false;
  currentUserBranch: number;
  currentSelectedNSUserBranch: number;
  currentSelectedSUserBranch: number;
  //global search
  searchText: string;
  isGlobalSearch: boolean = false;
  orderObj: any;
  NSSelectedRange: any;
  NSSelectedDateRange: any;
  SSelectedDateRange: any;
  SalesOrderFound: boolean = false;
  AppointmentFound: boolean = false;
  //added for popup

  salesOrderId: number;
  schAppointmentId: number;
  scheduleActionePopUp: string;
  salesOrder: SalesOrderInfoResponseModel;
  isAppointment: boolean;
  isTelehealth: boolean;
  selectedAppointmentTypePopUp: string;
  scheduleAppointment: boolean = false;
  voiceMailAppointment: boolean = false;
  appointmentNextCall: boolean = false;
  isCallStarted: boolean = false;
  IsRescheduleFacilityOption: boolean = false;
  rescheduleFacilityOption: string;
  callocales: any;
  selected: any;
  isBulkRefreshed: boolean = false;
  invalidDates: moment.Moment[] = [];
  voidFrom: string = "";
  isSaleOrder: boolean = false;
  appointmentType: string;
  salesOrderAppIds: any[];
  displayCancelAppointment: boolean;
  primaryInsuranceProviderList: PrimaryInsuranceProviderResponseModel[];
  selectedPrimaryInsuranceProvider: PrimaryInsuranceProviderResponseModel[];
  defaultModeofAppointment: string = "";
  pageSiges: QuickFilters[];
  selectedpage: QuickFilters;

  isSalesOrderBackHistory: boolean = false;
  title: string;
  isBrightreeSystemAppUpdate: Boolean = false;
  isBrightreeSystemAppUpdateSetting: Boolean = false;
  userPreferenceColumn: UserPreferencesModuleColumnResponseModel[];
  isOnlyFixedColumnVisible: boolean = false;

  ConfirmInvitePatients: boolean = false;
  restrictedSalesOrderIdToSendInvite: { crmSalesOrderAPPId: string, crmPatientName: string, crmBranch: string }[];
  salesOrderIdToSendInvite: any[];
  totalSelectedSendInviteSalesOrderIds: number = 0;
  updateStatusforminfo:statusInfo;
  isMultiSelected:string = 'False';

  ranges = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Last 3 Month': [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  };

  sRanges = {
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    Today: [moment(), moment()],
    Tomorrow: [moment().add(1, 'days'), moment().add(1, 'days')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Next 7 Days': [moment(), moment().add(6, 'days')],
    'Next 30 Days': [moment(), moment().add(29, 'days')],
    'Next Month': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')],
  };


  showRangeLabelOnInput: boolean;

  tooltips = [
    { date: moment(), text: 'Today is just unselectable' },
    { date: moment().add(2, 'days'), text: 'Yeeeees!!!' },
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, 'day'));
  }

  isTooltipDate = (m: moment.Moment) => {
    const tooltip = this.tooltips.find((tt) => tt.date.isSame(m, 'day'));
    if (tooltip) {
      return tooltip.text;
    } else {
      return false;
    }
  };

  rangeClicked(range): void {
    this.NSSelectedRange = range.label;

  }

  datesUpdated(range): void {
    this.NSSelectedDateRange = range;
  }

  clickEvent(index: number) {

    //this.selectedfilterIndex = this.selectedfilterIndex === index ? -1 : index;
    this.selectedfilterIndex = index;
    //event.currentTarget.className = "appointments-top-block__box active";
    //this.status = false;
  }

  toggelScheduledClass(index: number) {

    //this.selectedfilterSIndex = this.selectedfilterSIndex === index ? -1 : index;
    this.selectedfilterSIndex = index;
    //event.currentTarget.className = "appointments-top-block__box active";
    //this.status = false;
  }

  //Freeze
  cols: any[];
  frozencols: any[];
  colsSch: any[];
  frozencolsSch: any[];
  height: string = "400px";
  height1: string = "400px";


  ref: DynamicDialogRef | undefined;

  //Freeze
  constructor(private router: Router,
    private webStorageService: WebStorageService,
    private dialougeService: DialogService,
    private appointmentService: AppointmentService,
    private activatedRoute: ActivatedRoute,
    private globalSearchService: GlobalSearchService,
    private twillioCallService: TwillioCallService,
    messageService: MessageService, private _cdr: ChangeDetectorRef,
    private http: HttpClient,
    private userService: AdminUserService,
    private settingsService: AdminSettingsService,
    private formBuilder: UntypedFormBuilder,
    private wipStatusBtService: WipStatusBtService) {
    super(messageService);
    this.appDateFormat = this.webStorageService.getDateFormat();
    this.defaultModeofAppointment = this.webStorageService.getdefaultModeofAppointment();
    //Not schduled  Parameters
    this.totalRecords = 0;
    this.totalPages = 1;
    this.loading = false;
    this.salesOrderType = 'SalesOrderRequest';
    const loggedInUser = this.webStorageService.getCurrentUserToken();
    this.loggedInUserId = loggedInUser.userId;
    this.brightreeInternalUserId = loggedInUser.crmBrightreeUserId;
    this.pageSiges = [
      { name: '20', code: '20' },
      { name: '25', code: '25' },
      { name: '50', code: '50' },
      { name: '100', code: '100' },
    ];
    this.selectedpage = { name: '20', code: '20' };

    this.facilityVisitTypes = [
      { label: '"Same Facility', value: 'SF' },
      { label: 'Other Facility', value: 'OF' },

    ];

    this.minutes = [
      { label: "Schedule Appointment", value: 30 },
      { label: "Schedule Future Callback", value: 60 }
    ];
    this.selectedMinute = { label: "Schedule Appointment", value: 30 };

    this.currentUserBranch = this.webStorageService.getUserBranch();
    this.currentSelectedNSUserBranch = this.currentUserBranch;
    this.currentSelectedSUserBranch = this.currentUserBranch;
    const currentNavigationState = this.router.getCurrentNavigation()?.extras.state || window.history.state;;
    if (currentNavigationState && currentNavigationState.searchRequestModel) {

      this.searchRequestModel = currentNavigationState.searchRequestModel;
      this.index = Number(currentNavigationState.selectedTab);
      this.selectedfilterIndex = currentNavigationState.selectedfilterIndex;
      this.isAppointmentDisabled = currentNavigationState.isBookAppintment ? currentNavigationState.isBookAppintment : false;
      this.hasPageHistory = true;
      this.isSalesOrderBackHistory = true;
      //this.istodaysSummaryDashboard = currentNavigationState.istodaysSummaryDashboard != undefined ? currentNavigationState.istodaysSummaryDashboard : false;
      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.mySubscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // Trick the Router into believing it's last link wasn't previously loaded
          this.router.navigated = false;
        }
      });


    }

    this.callocales = {
      format: this.appDateFormat.dateFormat.toUpperCase(), // could be 'YYYY-MM-DDTHH:mm:ss.SSSSZ'
      displayFormat: this.appDateFormat.dateFormat.toUpperCase(), // default is format value
      direction: 'ltr', // could be rtl
      weekLabel: 'W',
      separator: ' To ', // default is ' - '
      cancelLabel: 'Cancel', // detault is 'Cancel'
      applyLabel: 'Apply', // detault is 'Apply'
      clearLabel: 'Clear', // detault is 'Clear'
      customRangeLabel: 'Custom range',
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort(),
      firstDay: 1 // first day is monday
    }

    this.quickNSFilters = [
      { name: 'Quick Filters', code: '' },
      { name: 'Today', code: 'Today' },
      { name: 'Yesterday', code: 'Yesterday' },
      { name: 'Last Week', code: 'LastWeek' },
      { name: 'Last Month', code: 'LastMonth' },
      { name: 'Custom Date', code: 'CustomDate' }
    ];
    this.quickSFilters = [
      // { name: 'Quick Appt. Date Filters', code: '' },
      { name: 'Quick Filters', code: '' },
      { name: 'Today', code: 'Today' },
      { name: 'Yesterday', code: 'Yesterday' },
      { name: 'Last Week', code: 'LastWeek' },
      { name: 'Last Month', code: 'LastMonth' },
      { name: 'Tommorrow', code: 'Tommorrow' },
      { name: 'Next Week', code: 'NextWeek' },
      { name: 'Next Month', code: 'NextMonth' },
      { name: 'Custom Date', code: 'CustomDate' }
    ];

    this.selectedSalesOrder = new SalesOrderSummaryResponseModel();
    this.selectedNonSColumns = new Array();
    this.dynamicNonSColumns = new Array();
    this.dynamicNonSColumns = [

      { fieldNo: 1, field: 'amountDue', sortFieldName: 'AmountDue', header: 'Amount Due', visible: false, style: 'width:15%', type: 'number', },
      { fieldNo: 3, field: 'crmClassificaitonduration', sortFieldName: 'CrmClassificaitonduration', header: 'Appt. Duration', visible: false, style: 'width:8em', type: 'number', },
      { fieldNo: 4, field: 'crmPatientEmail', sortFieldName: 'CrmPatientEmail', header: 'Email', visible: false, style: 'width:8em', type: 'string', },
      { fieldNo: 5, field: 'crmPatientPhoneNumber', sortFieldName: 'CrmPatientPhoneNumber', header: 'Phone Number', visible: false, style: 'width:8em', type: 'string', },
      { fieldNo: 17, field: 'crmPolicyHolderName', sortFieldName: 'crmPolicyHolderName', header: 'Primary Insurance', visible: false, style: 'width:8em', type: 'string', },
      { fieldNo: 16, visible: false, field: 'lastCallDate', header: 'Last Call Date & Time', sortFieldName: 'lastCallDate', style: 'width:15%', type: 'Date' },
    ];


    this.totalAppointmentRecords = 0;
    this.totalAppointmentPages = 1;
    this.AppointmentOrderType = 'AppointmentRequest';
    this.appointmentsalesOrderStatusMenuitems = new Array();
    // Get page info passed from edit page
    // so can use it to maintain paging and sorting
    this.getUserPreferenceColumn();
    this.selectedColumns = new Array();
    this.dynamicColumns = new Array();


    this.selectedDoctorResponseModel = new DoctorResponseModel();
    this.selectedfacilityResponseModel = new FacilityResponseModelDropdownList();
    this.title = "No Show Appointments";
    this.timeZoneList = this.webStorageService.getTimeZoneList();
  }

  onBack() {
    this.router.navigate(['admin/dashboard']);
  }

  async getWipStatusBTmapping() {

    this.loading = true;
    this.wipStatusBtService.getMappings()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          if (result && result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.wipStatusBTMappingResponseModel = result.responseModel;
            }
          }

        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });

  }

  async GetRCMConfigurationUrl() {
    this.loading = true;
    this.settingsService.GetRCMConfigurationUrl(Constants.pluginSettingCRMApp)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<RCMCofigurationUrl>) => {
        this.processResult<RCMCofigurationUrl>(result, () => {
          if (result && result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              let jsonData = result.responseModel
              this.patientBrighttreeURL = jsonData.patientRCMURL;
              this.salesOrderBrighttreeURL = jsonData.salesOrderRCMURL;
            }
          }

        });
      }, (httpResponseError) => {

        this.showErrorMessage(httpResponseError.message);
      });

  }

  private async getBranches() {
    this.progress.next(true);
    await this.userService.getUserBranches(this.loggedInUserId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise().then((result) => {
        if (result && result.isSuccess) {
          if (result.responseModel != undefined && result.responseModel != null) {
            this.branchResponseModel = result.responseModel;
            let selectedBranch = this.branchResponseModel.find(x => x.crmBranchId == this.currentUserBranch);
            if (selectedBranch) {
              this.selectedNSbranch = selectedBranch;
              this.selectedSbranch = selectedBranch;
            }
            else {
              this.selectedNSbranch = this.branchResponseModel[0];
              this.selectedSbranch = this.branchResponseModel[0];;
            }
          }
        }
      })
      .catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  onNavigateBrightTreeSalesOrderUrl(crmSalesOrderAPPId: number) {
    let salesOrderUrl = this.salesOrderBrighttreeURL.replace("{{SalesOrderID}}", crmSalesOrderAPPId);
    salesOrderUrl = salesOrderUrl.replace("{{InternalUserID}}", this.brightreeInternalUserId);
    window.open(salesOrderUrl, '_blank')
  }

  onNavigateBrightTreePatientUrl(crmPatientId: number) {
    let patienKeyUrl = this.patientBrighttreeURL.replace("{{PatientKey}}", crmPatientId);
    patienKeyUrl = patienKeyUrl.replace("{{InternalUserID}}", this.brightreeInternalUserId);

    window.open(patienKeyUrl, '_blank')
  }


  handleChange(e) {

    this.index = e.index;
  }

  headerCheckboxToggle(e) {

    this.selectedsalesOrders.forEach(value => {

      value.schIsLocked = false;

    });
  }



  async ngOnInit() {

    this.buildForm();
    //await this.getDefaultModeofAppointment();
    await this.getCancelVoidReasons();
    await this.GetRCMConfigurationUrl();
    this.globalSearchService.changeGlobalBranch
    .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
    .subscribe((branchId: number) => {

      if (branchId != null && branchId >= 0) {
        this.salesSelectedOrderCountModels = null;
        this.appointmentSelectedCountModels = null;
        this.selectedfilterIndex = 0;
        this.selectedfilterSIndex = -1;
        this.currentUserBranch = branchId;
        this.currentSelectedNSUserBranch = branchId;
        this.currentSelectedSUserBranch = branchId;
        this.initializeSearchRequestModel();
        this.getsalesorders();

        let selectedBranch = this.branchResponseModel.find(x => x.crmBranchId == this.currentUserBranch);
        if (selectedBranch) {
          this.selectedNSbranch = selectedBranch;
          this.selectedSbranch = selectedBranch;
        }
        else {
          this.selectedNSbranch = this.branchResponseModel[0];
          this.selectedSbranch = this.branchResponseModel[0];;
        }

      }
    });

    this.setPermissionforActions();

    this.isTelehealth = false;
    this.salesOrder = new SalesOrderInfoResponseModel();
    this.salesOrder.patientInfo = new PatientInfoResponseModel();
    this.salesOrder.doctorInfo = new DoctorSummaryResponseModel();
    this.appointment = new AppointmentInfoReponseModel();
    this.appointment.salesOrderInfo = new SalesOrderInfoResponseModel();
    this.appointment.salesOrderInfo.patientInfo = new PatientInfoResponseModel();
    this.appointment.salesOrderInfo.doctorInfo = new DoctorSummaryResponseModel();
    this.appointment.appointmentDetailInfo = new AppointmentDetailResponseModel();
    this.appointment.appointmentDetailInfo.facilityInfo = new FacilityInfoResponseModel();

    if (!this.isSalesOrderBackHistory) {
      this.initializeSearchRequestModel();

    }
    this.isSalesOrderBackHistory = false;
    await this.getSalesOrderStatus();
    await this.getWipStatusBTmapping();
    await this.getBranches();
    await this.getAllSalesOrderDoctors();
    await this.getAllSalesOrderDoctorFacility();
    await this.IsSalesOrdersLockedByUser();
    this.webStorageService.deleteRedirectFrom();
    await this.getAllPrimaryInsuranceProviders();
    await this.getAllClassificationType();

    if (this.searchRequestModel) {
      if (this.searchRequestModel.crmBranchId != null && this.searchRequestModel.crmBranchId != 0) {
        this.selectedNSbranch = this.branchResponseModel.find(x => x.crmBranchId === this.searchRequestModel.crmBranchId);
      }
      if (this.searchRequestModel.dictionaryFilter != null && this.searchRequestModel.dictionaryFilter.OrderingDoctor != null) {
        this.selectedDoctorResponseModel = this.doctorResponseModel.find(x => x.crmDoctorId === parseInt(this.searchRequestModel.dictionaryFilter.OrderingDoctor));
      }
      if (this.searchRequestModel.dictionaryFilter != null && this.searchRequestModel.dictionaryFilter.OrderingDoctorFacility != null) {
        this.selectedfacilityResponseModel = this.facilityResponseModelDropdownList.find(x => x.crmFacilityId === parseInt(this.searchRequestModel.dictionaryFilter.OrderingDoctorFacility));
      }
      if (this.searchRequestModel.selectedTimeZone != undefined) {
        let timeZones = new Array<string>();
        let selectedTime = new Array<TimeZoneAvailableResponseModel>();
        timeZones = this.searchRequestModel.selectedTimeZone.split(',');
        timeZones.forEach(x => {
          let t = this.timeZoneList.find(y => y.appTimeZoneOffSet === x);
          selectedTime.push(t);
        });
        this.selectedTimeZone = selectedTime;
      }
      if (this.searchRequestModel.selectedPrimaryInsurance != undefined) {
        let insurnace = new Array<string>();
        let selectedInsurance = new Array<PrimaryInsuranceProviderResponseModel>();
        insurnace = this.searchRequestModel.selectedPrimaryInsurance.split(',');
        insurnace.forEach(x => {
          let t = this.primaryInsuranceProviderList.find(y => y.crmPolicyHolderName === x);
          selectedInsurance.push(t);
        });
        this.selectedPrimaryInsuranceProvider = selectedInsurance;
      }

      if (this.searchRequestModel.selectedClassificationType != undefined) {
        let classification = new Array<string>();
        let selectedClassification = new Array<FilterClassificationTypeResponseModel>();
        classification = this.searchRequestModel.selectedClassificationType.split(',');
        classification.forEach(x => {
          let t = this.filterClassificationList.find(y => y.crmClassificationTypeId === parseInt(x));
          selectedClassification.push(t);
        });
        this.selectedClassificationType = selectedClassification;
      }

      if (this.searchRequestModel.searchFromDate != null && this.searchRequestModel.searchToDate != null) {
        let dt = { 'startDate': this.searchRequestModel.searchFromDate, 'endDate': this.searchRequestModel.searchToDate };
        this.NSSelectedDateRange = dt;
      }
    }



  }
  //Permission Check
  isSendInvitationPermission: boolean = false;
  isAppointmentScheduledPermission: boolean = false;
  isAppointmentRescheduledPermission: boolean = false;
  isAppointmentCancelPermission: boolean = false;
  isAppointmentMovedPermission: boolean = false;
  isAppointmentOverduePermission: boolean = false;
  isAppointmentNoshowPermission: boolean = false;
  isAppointmentCompletedPermission: boolean = false;
  isFacilitySchedulePermission: boolean = false;
  isAppointmentVoidPermission: boolean = false;
  setPermissionforActions() {
    this.features = this.webStorageService.getPermissions();
    if (this.features && this.features.length > 0) {

      let inPer = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentinvitation');
      if (inPer && inPer.isActive == true)
        this.isSendInvitationPermission = true;

      let inPer1 = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentscheduled');
      if (inPer1 && inPer1.isActive == true) {
        this.isAppointmentScheduledPermission = true;
        this.isAppointmentRescheduledPermission = true;
      }

      let inPer2 = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentcancel');
      if (inPer2 && inPer2.isActive == true)
        this.isAppointmentCancelPermission = true;

      //let inPer3 = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentrescheduled');
      //if (inPer3 && inPer3.isActive == true)
      //  this.isAppointmentRescheduledPermission = true;


      let inPer4 = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentmoved');
      if (inPer4 && inPer4.isActive == true)
        this.isAppointmentMovedPermission = true;

      let inPer5 = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentoverdue');
      if (inPer5 && inPer5.isActive == true)
        this.isAppointmentOverduePermission = true;

      let inPer6 = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentnoshow');
      if (inPer6 && inPer6.isActive == true)
        this.isAppointmentNoshowPermission = true;

      let inPer7 = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentcompleted');
      if (inPer7 && inPer7.isActive == true)
        this.isAppointmentCompletedPermission = true;

      let inPer8 = this.features.find(x => x.appModuleFeatureName.toLowerCase() == 'appointmentvoid');
      if (inPer8 && inPer8.isActive == true)
        this.isAppointmentVoidPermission = true;

    }
  }


  onBranchChange(event) {

    if (event.value) {
      this.currentSelectedNSUserBranch = Number(event.value.crmBranchId);
      this.searchRequestModel.crmBranchId = Number(event.value.crmBranchId);
    }
  }

  onSelectionChange(selection: any[]) {

    for (let i = selection.length - 1; i >= 0; i--) {
      let data = selection[i];
      if (this.isRowDisabled(data)) {
        selection.splice(i, 1);
      }
    }
    this.selectedsalesOrders = selection;
    if (this.selectedsalesOrders.length > 0)
      this.isDisabled = false;
    else
      this.isDisabled = true;
  }

  onSelectionSChange(selection: any[]) {
    this.selectedAppointments = selection;
    if (this.selectedAppointments.length > 0)
      this.isDisabled = false;
    else
      this.isDisabled = true;
  }

  ngAfterViewInit() {

    this.childrenComponent.changes.subscribe((comps: QueryList<TableHeaderCheckbox>) => {
      if (comps.length > 0) {
        const orig_updateCheckedState = this.headerCheckBox.updateCheckedState;
        const me = this;
        this.headerCheckBox.updateCheckedState = function () {

          const cars: any[] = me._table.filteredValue || me._table.value;
          const selection: any[] = me._table.selection;
          for (const car of cars) {
            if (!me.isRowDisabled(car)) {
              const selected = selection && selection.indexOf(car) >= 0;
              if (!selected) return false;
            }
          }
          if (selection && selection.length > 0)
            return true;
        };
      }
    });


    //this.loading = false;
    this.setFilters();
    // this.hasPageHistory = false;


    const frozenBody: HTMLElement | null = document.querySelector('.ui-table-frozen-view .ui-table-scrollable-body');
    const scrollableArea: HTMLElement | null = document.querySelector('.ui-table-scrollable-view.ui-table-unfrozen-view .ui-table-scrollable-body');
    if (frozenBody && scrollableArea) {
      frozenBody.addEventListener('wheel', e => {
        const canScrollDown = scrollableArea.scrollTop < (scrollableArea.scrollHeight - scrollableArea.clientHeight);
        const canScrollUp = 0 < scrollableArea.scrollTop;

        if (!canScrollDown && !canScrollUp) {
          return;
        }

        const scrollingDown = e.deltaY > 0;
        const scrollingUp = e.deltaY < 0;
        const scrollDelta = 100;

        if (canScrollDown && scrollingDown) {
          e.preventDefault();
          scrollableArea.scrollTop += scrollDelta;
        } else if (canScrollUp && scrollingUp) {
          e.preventDefault();
          scrollableArea.scrollTop -= scrollDelta;
        }
      });
    }
  }

  isRowDisabled(data: any): boolean {
    return data.schIsLocked === true
  }

  private setFilters() {
    if (!this.hasPageHistory)
      return;

    if (this.index === 0) {
      if (this.searchRequestModel.dictionaryFilter['SearchText'])
        this.searchBox.nativeElement.value = this.searchRequestModel.dictionaryFilter['SearchText'];
    }
    else {

      if (this.searchRequestModel.dictionaryFilter['SearchText'])
        this.searchBoxAppointment.nativeElement.value = this.searchRequestModel.dictionaryFilter['SearchText'];

    }
  }

  ngOnDestroy() {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }

    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }

    if (this.globalSearchService.changeGlobalBranch) {
      this.globalSearchService.changeGlobalBranch.next(null);
      //this.globalSearchService.changeGlobalBranch.complete();
    }


    if (this.progress)
      this.progress.complete();
  }

  //Start : Non Scheduled Events

  onView(salesOrderId: string, salesorderStatus: string, schAppointmentId: number) {
    if (schAppointmentId > 0) {
      let setUrl = '/admin/appointments/detail/' + schAppointmentId + '/noshow';
      this.router.navigate([setUrl], { state: { searchRequestModel: this.searchRequestModel, selectedTab: this.index, selectedfilterIndex: this.selectedfilterIndex } });
    }
    else {
      let setUrl = '/admin/appointments/salesorders/detail/' + salesOrderId + '/noshow';
      this.router.navigate([setUrl], { state: { searchRequestModel: this.searchRequestModel, selectedTab: this.index, isBookAppintment: this.isAppointmentDisabled, selectedfilterIndex: this.selectedfilterIndex } });
    }
  }

  showAppointmentDialog(crmSalesOrderId, schAppointmentId) {
    if (!this.checkCall()) {
      this.showWarningMessage('Only one patient can be called at one time.');
      return;
    }
    this.salesOrderId = crmSalesOrderId;
    this.isAppointment = true;
    this.indexActionTab = 0;
    this.schAppointmentId = schAppointmentId;
    this.scheduleActionePopUp = this.isAppointment ? 'Reschedule' : 'Schedule';
    //this.getAppointmentInfo(this.schAppointmentId);

    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true,
      closable: true,
      styleClass: 'book-appt-popup-outer',
      data: {
        crmSalesOrderId: crmSalesOrderId,
        isRescheduledRequest: true,
        isScheduleOrder: true,
        isAppointment: true,
        schAppointmentId: schAppointmentId,
        isVoidOrder: false,
        isCancelOrder: false,
        isCall: false,
        voidFrom: this.voidFrom ? "P" : this.voidFrom,
        defaultModeofAppointment: this.defaultModeofAppointment
      },
    });

    ref.onClose.subscribe(() => {
      this.HangUpCall();

    });
  }

  showCancelAppointmentDialog(crmSalesOrderId, schAppointmentId) {
    if (!this.checkCall()) {
      this.showWarningMessage('Only one patient can be called at one time.');
      return;
    }
    this.salesOrderId = crmSalesOrderId;
    this.isAppointment = true;
    this.indexActionTab = 0;
    this.schAppointmentId = schAppointmentId;
    this.scheduleActionePopUp = this.isAppointment ? 'Reschedule' : 'Schedule';
    //this.getAppointmentInfo(this.schAppointmentId);

    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true,
      closable: true,
      styleClass: 'book-appt-popup-outer',
      data: {
        isScheduleOrder: false,
        crmSalesOrderId: crmSalesOrderId,
        isRescheduledRequest: true,
        isAppointment: true,
        schAppointmentId: schAppointmentId,
        isVoidOrder: false,
        isCancelOrder: true,
        isCall: false,
        defaultModeofAppointment: this.defaultModeofAppointment
      },
    });

    ref.onClose.subscribe(() => {
      this.HangUpCall();
    });


  }

  showVoidAppointmentDialog(crmSalesOrderId, schAppointmentId) {
    if (!this.checkCall()) {
      this.showWarningMessage('Only one patient can be called at one time.');
      return;
    }
    this.salesOrderId = crmSalesOrderId;
    this.isAppointment = true;
    this.indexActionTab = 0;
    this.schAppointmentId = schAppointmentId;
    this.scheduleActionePopUp = this.isAppointment ? 'Reschedule' : 'Schedule';
    //this.getAppointmentInfo(this.schAppointmentId);

    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true,
      closable: true,
      styleClass: 'book-appt-popup-outer',
      data: {
        isScheduleOrder: false,
        crmSalesOrderId: crmSalesOrderId,
        isRescheduledRequest: true,
        isAppointment: true,
        schAppointmentId: schAppointmentId,
        isVoidOrder: true,
        isCancelOrder: false,
        isCall: false,
        voidFrom: this.voidFrom ? "P" : this.voidFrom,
        defaultModeofAppointment: this.defaultModeofAppointment
      },
    });

    ref.onClose.subscribe(() => {
      this.HangUpCall();

    });


  }

  showCallAppointmentDialog(crmSalesOrderId, schAppointmentId) {
    if (!this.checkCall()) {
      this.showWarningMessage('Only one patient can be called at one time.');
      return;
    }
    this.salesOrderId = crmSalesOrderId;
    this.isAppointment = true;
    this.indexActionTab = 0;
    this.schAppointmentId = schAppointmentId;
    this.scheduleActionePopUp = this.isAppointment ? 'Reschedule' : 'Schedule';
    //this.getAppointmentInfo(this.schAppointmentId);

    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true,
      closable: true,
      styleClass: 'book-appt-popup-outer',
      data: {
        isScheduleOrder: false,
        crmSalesOrderId: crmSalesOrderId,
        isRescheduledRequest: true,
        isAppointment: true,
        schAppointmentId: schAppointmentId,
        isVoidOrder: false,
        isCancelOrder: false,
        isCall: true,
        defaultModeofAppointment: this.defaultModeofAppointment
      },
    });

    ref.onClose.subscribe(() => {
      this.HangUpCall();

    });

  }

  recheduleFacilityVisitOptions() {

    if (this.selectedAppointmentTypePopUp == "FacilityVisit") {
      this.rescheduleFacilityOption = "SF";
      this.IsRescheduleFacilityOption = true;
    }
    else
      this.IsRescheduleFacilityOption = false;
  }

  selectNonScheduleSalesOrder(event, selSalesOrder: SalesOrderSummaryResponseModel, overlaypanel: OverlayPanel) {

    this.selectedSalesOrder = selSalesOrder;
    overlaypanel.toggle(event);
  }

  AddNonSColumnInTable(event, col: UserPreferencesModuleColumnResponseModel[]) {
    this.loading = true;
    let isChecked = event.checked;

    let arruserModuleColumn = new Array();
    let IsAnyColVisible = col.filter(x => x.preferenceVisible === true);
    if (IsAnyColVisible.length == 0) {
      this.isOnlyFixedColumnVisible = true;
    }
    else {
      this.isOnlyFixedColumnVisible = false;
    }
    this.userPreferenceColumn.forEach(x => {
      x.visible = x.preferenceVisible;
    })
    col.forEach(x => {
      let userModuleColumn = new UserWiseModuleColumn();
      userModuleColumn.UserInfoId = this.loggedInUserId;
      userModuleColumn.ModuleId = x.moduleId;
      userModuleColumn.ColumnName = x.field;
      userModuleColumn.IsActive = x.preferenceVisible;
      userModuleColumn.Id = x.userModuleColumnId;
      userModuleColumn.UserPreferencesDisplayOrder = col.findIndex(y => y.id === x.id);
      arruserModuleColumn.push(userModuleColumn);
    });

    this.appointmentService.addUserPreferenceColumn(arruserModuleColumn)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<boolean>) => {
        this.processResult<boolean>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.showSuccessMessage("Column display settings save successfully.")
            }
          }
        });

      }, (httpResponseError) => {
        this.loading = false
        this.showErrorMessage(httpResponseError.message);
      });
  }

  onSalesOrderCountClick(salesOrderCount: SalesOrdersCountModel, index: number) {

    // this.selectedfilterIndex = this.selectedfilterIndex === index ? -1 : index;
    this.selectedfilterIndex = this.selectedfilterIndex === index ? 0 : index;
    //this.selectedfilterIndex = index;
    this.searchRequestModel.crmBranchId = this.currentSelectedNSUserBranch;
    this.searchRequestModel.dictionaryFilter = {}
    this.searchRequestModel.dictionaryFilter['SearchText'] = this.searchBox.nativeElement.value;

    if (this.selectedfilterIndex != -1) {
      this.salesSelectedOrderCountModels = salesOrderCount;
      if (salesOrderCount.salesOrderStatus.toUpperCase() == "TELEHEALTHREQUEST") {
        this.searchRequestModel.dictionaryFilter['Telehealth'] = 'true';
      }
      else if (salesOrderCount.salesOrderStatus.toUpperCase() == "CLINICAPPOINTMENTREQUEST") {
        this.searchRequestModel.dictionaryFilter['ClinicAppointmentCallback'] = 'true';
      }
      else
        this.searchRequestModel.dictionaryFilter['SalesOrdeStatus'] = salesOrderCount.salesOrderStatusDisplayble;
    }
    else
      this.salesSelectedOrderCountModels = null;

    let startDate = this.NSSelectedDateRange.startDate.format("YYYY/MM/DD");
    let endDate = this.NSSelectedDateRange.endDate.format("YYYY/MM/DD");

    if (startDate && endDate) {
      startDate = moment(startDate).toDate();
      endDate = moment(endDate).toDate();
      if (startDate > endDate) {
        this.showWarningMessage("From Date should not be greater than To Date.");
        return;
      }
    }
    if (startDate && endDate) {
      this.searchRequestModel.dictionaryFilter['CustomDateFilter'] = 'CustomDate';
      this.searchRequestModel.searchFromDate = startDate;
      this.searchRequestModel.searchToDate = endDate;
    }

    this.resetPageIndex();

    this.getsalesorders();
  }

  onSearchButtonClick() {

    this.searchRequestModel.crmBranchId = this.currentSelectedNSUserBranch;
    this.searchRequestModel.dictionaryFilter = {}
    this.searchRequestModel.dictionaryFilter['SearchText'] = this.searchBox.nativeElement.value;
    let selSatatus = this.salesSelectedOrderCountModels;
    if (selSatatus) {
      if (selSatatus.salesOrderStatus.toUpperCase() == "TELEHEALTHREQUEST") {
        this.searchRequestModel.dictionaryFilter['Telehealth'] = 'true';
      }
      else if (selSatatus.salesOrderStatus.toUpperCase() == "CLINICAPPOINTMENTREQUEST") {
        this.searchRequestModel.dictionaryFilter['ClinicAppointmentCallback'] = 'true';
      }
      else
        this.searchRequestModel.dictionaryFilter['SalesOrdeStatus'] = selSatatus.salesOrderStatusDisplayble;
    }
    let startDate = this.NSSelectedDateRange.startDate.format("YYYY/MM/DD");
    let endDate = this.NSSelectedDateRange.endDate.format("YYYY/MM/DD");

    if (startDate && endDate) {
      startDate = moment(startDate).toDate();
      endDate = moment(endDate).toDate();
      if (startDate > endDate) {
        this.showWarningMessage("From Date should not be greater than To Date.");
        return;
      }
    }
    if (startDate && endDate) {
      this.searchRequestModel.dictionaryFilter['CustomDateFilter'] = 'CustomDate';
      this.searchRequestModel.searchFromDate = startDate;
      this.searchRequestModel.searchToDate = endDate;
    }

    this.resetPageIndex();
    this.getsalesorders();
  }

  getTotalRows() {
    // Set page size to 'totalRecords' when page size is 'All'

    if (this.searchRequestModel != null && this.searchRequestModel != undefined)
      return this.searchRequestModel.PageSize;

    return this.totalRecords;
  }


  onStatusChange(event) {

    this.searchRequestModel.dictionaryFilter['SearchText'] = this.searchBox.nativeElement.value;

    if (event.value != null)
      this.searchRequestModel.dictionaryFilter['SalesOrdeStatus'] = event.value.wipStatesName;
    this.resetPageIndex();
    this.getsalesorders();
  }

  onLazyLoad(event: LazyLoadEvent) {

    this.searchRequestModel.FirstRecordIndex = event.first;
    this.searchRequestModel.CurrentPageIndex = event.first / event.rows;
    this.searchRequestModel.PageSize = Number(this.selectedpage.code);//event.rows;

    this.searchRequestModel.SortByColumnName = event.sortField;
    this.searchRequestModel.IsAscendingOrder = event.sortOrder === 1 ? true : false;
    this.searchRequestModel.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';



    this.getsalesorders();
  }

  LockAppoinments() {

    if (!this.selectedsalesOrders || this.selectedsalesOrders.length <= 0) {
      this.showWarningMessage('Please select sales order(s)');
      return;
    }

    let appointmentUpdateStatus: AppointmentCallListResponseModel[] = new Array();
    this.selectedsalesOrders.forEach(value => {

      let appointmentUpdateStatusRequestModel = new AppointmentCallListResponseModel();
      appointmentUpdateStatusRequestModel.SchAppointmentId = 0;
      appointmentUpdateStatusRequestModel.CrmSalesorderId = value.crmSalesOrderId;
      appointmentUpdateStatusRequestModel.AppUserInfoId = this.loggedInUserId;
      appointmentUpdateStatus.push(appointmentUpdateStatusRequestModel);
    })

    this.loading = true;
    this.appointmentService.LockAppointments(appointmentUpdateStatus)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<boolean>) => {
        this.processResult<boolean>(result, () => {
          this.showSuccessMessage('Sales order has been locked.');
          this.IsSalesOrdersLockedByUser();
          this.selectedsalesOrders = [];
          this.getsalesorders();
          this._cdr.detectChanges();
        });

      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });

  }
  private resetPageIndex() {
    this.searchRequestModel.CurrentPageIndex = 0;
    this.searchRequestModel.FirstRecordIndex = 0;
  }

  private initializeSearchRequestModel() {

    if (this.hasPageHistory)
      return;

    if (this.searchRequestModel) {
      this.searchRequestModel = new SearchRequestModel();
    }
    this.searchRequestModel.crmBranchId = this.currentSelectedNSUserBranch != undefined ? this.currentSelectedNSUserBranch : 0;
    if (this.isGlobalSearch) {
      this.searchRequestModel.dictionaryFilter = {}
      this.searchRequestModel.dictionaryFilter['SearchText'] = this.searchText;
    }

    this.searchRequestModel.appUserInfoId = this.loggedInUserId;
    this.searchRequestModel.FirstRecordIndex = 0;
    this.searchRequestModel.CurrentPageIndex = 0;
    this.searchRequestModel.PageSize = +this.pageSizes[0];
    this.searchRequestModel.SortOrder = 'ASC';
    this.searchRequestModel.SortByColumnName = "crmPatientName";
  }

  private async getSalesOrderStatus() {
    this.progress.next(true);
    await this.appointmentService.GetAllWIPStatesBySalesOrderType(this.salesOrderType)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise()
      .then((result) => {
        this.processResult<WIPStatesResponseModel[]>(result, () => {

          if (result && result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.salesOrderStatus = result.responseModel;
              //loop to add & check the dynamic options -- start

              this.salesOrderStatus.forEach(value => {
                if (this.isAppointmentCompletedPermission && value.wipStatesName.toLowerCase() == 'void') {
                  this.appointmentsalesOrderStatusMenuitems.push({
                    id: value.wipStatesId.toString(),
                    label: value.wipStatesName, command: (event) => {
                      // this.updateVoidSalesOrder();
                    }
                  });
                }
              });
            }
          }

        });
      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  private getsalesorders() {
    this.loading = true;
    this.dataExpressionloading = true;
    this.appointmentService.GetAllNotShowAppointment(this.searchRequestModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<PagedResponseModel<SalesOrderSummaryResponseModel>>) => {
        this.processResult<PagedResponseModel<SalesOrderSummaryResponseModel>>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              const pagedResponse = result.responseModel;
              if (pagedResponse) {
                this.salesOrders = pagedResponse.results;
                this.totalRecords = pagedResponse.totalRecords;
                this.totalPages = pagedResponse.totalPages;


                if (!this.searchRequestModel.PageSize)
                  this.searchRequestModel.PageSize = pagedResponse.totalRecords;

                this.isBulkRefreshed = this.dataExpressionloading = this.loading = false;
              }
            }
          }
        });

      }, (httpResponseError) => {

        this.showErrorMessage(httpResponseError.message);
        this.loading = false;
        this.dataExpressionloading = false;
      });
  }

  ViewLockedAppoinments() {
    this.router.navigate(['/admin/appointments/view-locked-appointments/'], { state: { selectedTab: this.index } });
  }

  AddColumnInTable(event, fieldNo) {

    this.colsSch.forEach(value => {

      if (value.fieldNo == fieldNo) {
        let isChecked = event.checked;
        if (isChecked)
          value.visible = true;
        else
          value.visible = false;
      }
    });

    this.selectedColumns = this.colsSch.filter(x => x.visible === true);
  }

  selectScheduleSalesOrder(event, selectedAppointment: AppointmentSummaryResponseModel, overlaypanel: OverlayPanel) {

    this.selectedAppointment = selectedAppointment;
    overlaypanel.toggle(event);
  }


  onMeuSelection(selectedMenuitem) {



    let status: string = selectedMenuitem.label;
    let statusUpdated: string = selectedMenuitem.label;
    if (status.toLowerCase() == 'voided') {
      status = 'void';
      statusUpdated = 'voided';
    }
    if (status.toLowerCase() == 'booked') {
      status = 'book';
      statusUpdated = 'booked';
    }
    if (status.toLowerCase() == 'complete') {
      status = 'complete';
      statusUpdated = 'completed';
    }
    if (status.toLowerCase() == 'no show') {
      status = 'no show';
      statusUpdated = 'no show';
    }

    let appointmentUpdateStatus: AppointmentUpdateStatusRequestModel[] = new Array();
    //if(this.selectedsalesOrders.length>0)
    //this.selectedAppointments.push(this.selectedsalesOrders)
    this.selectedAppointments.forEach(value => {

      let appointmentUpdateStatusRequestModel = new AppointmentUpdateStatusRequestModel();
      appointmentUpdateStatusRequestModel.SchAppointmentId = value.schAppointmentId;
      appointmentUpdateStatusRequestModel.SchAppointmentStatus = selectedMenuitem.id;
      appointmentUpdateStatusRequestModel.CrmFacilityId = value.appointmentDetailInfo.crmFacilityId;
      appointmentUpdateStatusRequestModel.CrmTherapistId = value.appointmentDetailInfo.crmTherapistId;
      appointmentUpdateStatus.push(appointmentUpdateStatusRequestModel);
    })

    //this.dialogService.showConfirmDialog(`Are you sure you want to delete '${name}'`)
    //  .subscribe((response: boolean) => {
    //    if (!response)
    //      return;

    this.dialougeService.open(ConfirmDialogComponent, {
      data:
      {
        message: 'Are you sure you want to ' + status + ' appointment ?',
      },
      header: 'Confirmation'
    }).onClose.subscribe((response: boolean) => {
      if (!response) {
        return;
        //this.selectedAppointmentOrderStatus = this.defaultselectedAppointmentOrderStatus;
      }

      this.loading = true;
      this.appointmentService.UpdateAppointmentStatus(appointmentUpdateStatus)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
        .subscribe((result: ResultOfT<boolean>) => {
          this.processResult<boolean>(result, () => {


            this.showSuccessMessage('Appointment has been ' + statusUpdated + ' successfully.');
            //this.showSuccessMessage('Status has been updated successfully.');
            this.selectedAppointments = [];
            if (this.selectedAppointments.length > 0)
              this.isDisabled = false;
            else
              this.isDisabled = true;
            this._cdr.detectChanges();
          });

        }, (httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        });
    });


  }

  private async getCallConfig() {
    this.progress.next(true);
    await this.settingsService.getCallConfig()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise()
      .then((result) => {
        this.processResult<CallConfigModel>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.callConfigModel = result.responseModel;
            }
          }
        });
      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  private async IsSalesOrdersLockedByUser() {
    this.progress.next(true);
    this.appointmentService.IsSalesOrdersLockedByUser(this.loggedInUserId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result: ResultOfT<boolean>) => {
        this.processResult<boolean>(result, () => {
          if (result && result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.isLockedAppointments = result.responseModel;
            }
          }
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });



  }

  async Hangup() {
    console.log('Hanging up...');
    if (this.device) {
      this.device.disconnectAll();
      this.isCallStarted = false;
    }
    if (this.callId) {
      await this.UpdateCall();
    } else {
      //this.callPopup = false;
      this._cdr.detectChanges();
    }
  }

  async HangupVoiceCall() {
    console.log('Hanging up...');
    if (this.device) {

      this.device.disconnectAll();
      this.isCallStarted = false;
    }
    await this.SaveCall("V");
    await this.SendVoiceMail();
  }

  async RescheduleHangup() {
    console.log('Hanging up...');
    if (this.device) {
      this.isCallStarted = false;
      this.device.disconnectAll();
    }
    if (this.reschedulecallId) {
      await this.UpdateRescheduleCall();
    }
    else {
      this.SchedulePopup = false;
      this._cdr.detectChanges();
    }

  }

  async UpdateRescheduleCall() {
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    this.appointmentCallResponseModel = new AppointmentCallResponseModel();
    if (currentUserToken && currentUserAuthToken.token) {
      if (this.actionType !== "S") {
        if (this.calldate && this.calltime) {
          this.calltime = new Date(this.calldate.toDateString() + ' ' + this.calltime.toTimeString());
          this.appointmentCallResponseModel.schNextCallDueDate = this.calltime;
        }
        else {
          this.calltime = new Date(new Date().setDate(new Date().getDate() + 3));
          this.appointmentCallResponseModel.schNextCallDueDate = this.calltime;
        }
        if (this.callnote)
          this.appointmentCallResponseModel.schAppointmentCallNote = this.callnote;
        else
          this.appointmentCallResponseModel.schAppointmentCallNote = "Not answered";
      }
      this.appointmentCallResponseModel.schAppointmentCallId = this.reschedulecallId;
      this.appointmentCallResponseModel.schAppointmentId = this.appointment.schAppointmentId;
      this.appointmentCallResponseModel.modifiedByUserInfoId = currentUserToken.userId;
      this.appointmentCallResponseModel.callSID = this.rescheduleCallSID;
      await this.appointmentService.UpdateCallStatus(this.appointmentCallResponseModel)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
        .toPromise().then((result) => {

          if (result.responseModel) {
            this.showSuccessMessage('Next call noted');
            this.isCallStarted = false;
            this.SchedulePopup = false;
            this._cdr.detectChanges();
          }
          else {
            this.showWarningMessage('Error occurred.');
          }

        }).catch((httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        });
    }
  }

  async RescheduleHangupVoiceCall() {
    console.log('Hanging up...');
    if (this.device) {
      this.isCallStarted = false;
      this.device.disconnectAll();
    }
    await this.ReschduleSaveCall("V");
    await this.ReschduleSendVoiceMail();
  }

  async ReschduleSaveCall(saveDate: string) {
    this.appointmentCallResponseModel = new AppointmentCallResponseModel();
    if (this.connection)
      this.rescheduleCallSID = this.connection.parameters.CallSid;
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      if (saveDate !== "S") {
        if (this.calldate && this.calltime) {
          this.calltime = new Date(this.calldate.toDateString() + ' ' + this.calltime.toTimeString());
          this.appointmentCallResponseModel.schNextCallDueDate = this.calltime;
        }
        else {
          this.calltime = new Date(new Date().setDate(new Date().getDate() + 3));
          this.appointmentCallResponseModel.schNextCallDueDate = this.calltime;
        }
        if (this.callnote)
          this.appointmentCallResponseModel.schAppointmentCallNote = this.callnote;
        else
          this.appointmentCallResponseModel.schAppointmentCallNote = "Not answered";
      }
      this.appointmentCallResponseModel.crmSalesOrderId = this.appointment.salesOrderInfo.crmSalesorderId;
      this.appointmentCallResponseModel.schAppointmentId = this.appointment.schAppointmentId;
      this.appointmentCallResponseModel.modifiedByUserInfoId = currentUserToken.userId;
      this.appointmentCallResponseModel.schAppointmentCallBy = currentUserToken.userId;
      this.appointmentCallResponseModel.schAppointmentCallByPerson = currentUserToken.userFullName;
      this.appointmentCallResponseModel.schAppointmentCallByRole = currentUserToken.roleName;
      this.appointmentCallResponseModel.schAppointmentCallListId = 0;
      this.appointmentCallResponseModel.callSID = this.rescheduleCallSID;
      await this.appointmentService.SaveCall(this.appointmentCallResponseModel)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
        .toPromise().then((result) => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.reschedulecallId = result.responseModel.schAppointmentCallId;
              this.SchedulePopup = false;
              this._cdr.detectChanges();
            }

          }
          else {
            this.showWarningMessage('Error occurred.');
          }

        }).catch((httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        });
    }
  }

  async ReschduleSendVoiceMail() {
    await this.appointmentService.SendVoiceMail(this.reschedulecallId.toString(), this.loggedInUserId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise().then((result) => {
        if (result.responseModel) {
          this.showSuccessMessage('Voice mail has been Sent to Patient.');
          this.SchedulePopup = false;
          this.isCallStarted = false;
          this._cdr.detectChanges();
        }
        else {
          this.showWarningMessage('Error occurred while sending voice mail.');
        }

      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  actionChange() {
    this.scheduleAppointment = false;
    this.schedulecall = false;
    this.calldate = null;
    this.calltime = null;
    this.callnote = '';
    if (this.actionType === "S") {
      this.schedulecall = false;
      this.scheduleAppointment = true;
    }
    else if (this.actionType === "C") {
      this.schedulecall = true;
      this.scheduleAppointment = false;

    }
    else if (this.actionType === "V") {
      this.schedulecall = false;
      this.scheduleAppointment = false;

    }
  }

  async bookAppointment() {
    this.webStorageService.storeRedirectFrom('appt');
    if (this.actionType === "S") {
      if (this.callId) {
        await this.UpdateCall();
      }
      else {
        await this.SaveCall(this.actionType);
      }
      if (this.selectedAppointmentType == "FacilityVisit")
        this.router.navigate(['/admin/book-appointment/confirm-date-time-slot/', this.selectedSalesOrder.crmSalesOrderId]);
      else if (this.selectedAppointmentType == "HomeVisit")
        this.router.navigate(['/admin/book-appointment/home-visit-confirm-date-time-slot/', this.selectedSalesOrder.crmSalesOrderId]);
      else
        this.router.navigate(['/admin/book-appointment/telehealth-confirm-date-time-slot/', this.selectedSalesOrder.crmSalesOrderId]);
    }
    else if (this.actionType === "C") {
      if (!this.calldate) {
        this.showWarningMessage('Please select next call due date');
        return;
      }
      else if (!this.calltime) {
        this.showWarningMessage('Please select next call due time');
        return;
      }
      else if (!this.callnote) {
        this.showWarningMessage('Please add a call note');
        return;
      }
      if (this.device) {
        this.device.disconnectAll();
      }
      if (this.callId) {

        await this.UpdateCall();
      }
      else {
        await this.SaveCall(this.actionType);
      }
    }
    else if (this.actionType === "V") {
      if (this.device) {
        this.isCallStarted = false;
        this.device.disconnectAll();
      }
      if (this.callId) {
        this.isCallStarted = false;
        await this.UpdateCall();
      }
      else {
        this.isCallStarted = false;
        await this.SaveCall(this.actionType);
      }
      await this.SendVoiceMail();
    }
  }

  async SaveCall(saveDate: string) {

    this.appointmentCallResponseModel = new AppointmentCallResponseModel();
    if (this.connection)
      this.callSID = this.connection.parameters.CallSid;
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      if (saveDate !== "S") {
        if (this.calldate && this.calltime) {
          this.calltime = new Date(this.calldate.toDateString() + ' ' + this.calltime.toTimeString());
          this.appointmentCallResponseModel.schNextCallDueDate = this.calltime;
        }
        else {
          this.calltime = new Date(new Date().setDate(new Date().getDate() + 3));
          this.appointmentCallResponseModel.schNextCallDueDate = this.calltime;
        }
        if (this.callnote)
          this.appointmentCallResponseModel.schAppointmentCallNote = this.callnote;
        else
          this.appointmentCallResponseModel.schAppointmentCallNote = "Not answered";
      }
      this.appointmentCallResponseModel.crmSalesOrderId = this.selectedSalesOrder.crmSalesOrderId;
      this.appointmentCallResponseModel.modifiedByUserInfoId = currentUserToken.userId;
      this.appointmentCallResponseModel.schAppointmentCallBy = currentUserToken.userId;
      this.appointmentCallResponseModel.schAppointmentCallByPerson = currentUserToken.userFullName;
      this.appointmentCallResponseModel.schAppointmentCallByRole = currentUserToken.roleName;
      this.appointmentCallResponseModel.schAppointmentCallListId = 0;
      this.appointmentCallResponseModel.callSID = this.callSID;
      await this.appointmentService.SaveCall(this.appointmentCallResponseModel)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
        .toPromise().then((result) => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.callId = result.responseModel.schAppointmentCallId;
              this.callPopup = false;
              this.getsalesorders();
              this._cdr.detectChanges();
            }
            else {
              this.showWarningMessage('Error occurred.');
            }
          }

        }).catch((httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        });
    }
  }

  async UpdateCall() {
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    this.appointmentCallResponseModel = new AppointmentCallResponseModel();
    if (currentUserToken && currentUserAuthToken.token) {
      if (this.actionType !== "S") {
        if (this.calldate && this.calltime) {
          this.calltime = new Date(this.calldate.toDateString() + ' ' + this.calltime.toTimeString());
          this.appointmentCallResponseModel.schNextCallDueDate = this.calltime;
        }
        else {
          this.calltime = new Date(new Date().setDate(new Date().getDate() + 3));
          this.appointmentCallResponseModel.schNextCallDueDate = this.calltime;
        }
        if (this.callnote)
          this.appointmentCallResponseModel.schAppointmentCallNote = this.callnote;
        else
          this.appointmentCallResponseModel.schAppointmentCallNote = "Not answered";
      }
      this.appointmentCallResponseModel.schAppointmentCallId = this.callId;
      this.appointmentCallResponseModel.modifiedByUserInfoId = currentUserToken.userId;
      this.appointmentCallResponseModel.callSID = this.callSID;
      await this.appointmentService.UpdateCallStatus(this.appointmentCallResponseModel)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
        .toPromise().then((result) => {

          if (result.isSuccess) {
            this.showSuccessMessage('Next call noted');
            //this.isCallStarted = false;
            // this.callPopup = false;
            this._cdr.detectChanges();
            // this.getsalesorders();
          }
          else {
            this.showWarningMessage('Error occurred.');
          }
        }).catch((httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        });
    }
  }

  async SendVoiceMail() {

    await this.appointmentService.SendVoiceMail(this.callId.toString(), this.loggedInUserId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise().then((result) => {
        if (result.responseModel) {
          this.showSuccessMessage('Voice mail has been Sent to Patient.');
          // this.callPopup = false;
          this.isCallStarted = false;
          this._cdr.detectChanges();
        }
        else {
          this.showWarningMessage('Error occurred while sending voice mail.');
        }

      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  async bookAppointmentPopup() {

    if (this.actionType === "S") {
      if (this.reschedulecallId) {
        await this.UpdateRescheduleCall();
      }
      else {
        await this.ReschduleSaveCall(this.actionType);
      }
      if (this.selectedAppointmentTypePopUp == "FacilityVisit") {
        if (this.rescheduleFacilityOption == "SF") {
          this.webStorageService.deleteSelectedFacilies();
          if (this.isTelehealth)
            this.router.navigate(['/admin/book-appointment/search-nearby-facility/', this.appointment.crmSalesorderId]);
          else {

            this.getFacilityData(this.appointment.appointmentDetailInfo.crmFacilityId, this.appointment.crmSalesorderId);
          }
        }
        else {
          this.webStorageService.deleteSelectedFacilies();
          // this.router.navigate(['/admin/book-appointment/search-nearby-facility/', this.appointment.crmSalesorderId]);
          this.router.navigate(['/admin/book-appointment/confirm-date-time-slot/' + this.appointment.crmSalesorderId]);
        }
      }
      else if (this.selectedAppointmentTypePopUp == "HomeVisit")
        this.router.navigate(['/admin/book-appointment/home-visit-confirm-date-time-slot/', this.appointment.crmSalesorderId]);
      else
        this.router.navigate(['/admin/book-appointment/telehealth-confirm-date-time-slot/', this.appointment.crmSalesorderId]);
    }
    else if (this.actionType === "C") {
      if (!this.calldate) {
        this.showWarningMessage('Please select next call due date');
        return;
      }
      else if (!this.calltime) {
        this.showWarningMessage('Please select next call due time');
        return;
      }
      else if (!this.callnote) {
        this.showWarningMessage('Please add a call note');
        return;
      }
      if (this.device) {
        this.device.disconnectAll();
      }
      if (this.reschedulecallId) {

        await this.UpdateRescheduleCall();
      }
      else {
        await this.ReschduleSaveCall(this.actionType);
      }
    }
    else if (this.actionType === "V") {
      if (this.device) {
        this.isCallStarted = false;
        this.device.disconnectAll();
      }
      if (this.reschedulecallId) {
        this.isCallStarted = false;
        await this.UpdateRescheduleCall();
      }
      else {
        this.isCallStarted = false;
        await this.ReschduleSaveCall(this.actionType);
      }
      await this.ReschduleSendVoiceMail();
    }

    this.SchedulePopup = false;
  }
  private async getFacilityData(facilityId, crmSalesOrderId) {

    let facilitySearchRequest: FacilitySearchRequestModel = new FacilitySearchRequestModel();
    facilitySearchRequest.crmSalesOrderId = crmSalesOrderId;
    facilitySearchRequest.crmFacilityId = facilityId;
    facilitySearchRequest.isAppointment = this.isAppointment;
    //for time zone changes
    //facilitySearchRequest.patientTimeZone = this.isBillingAddress ? this.salesOrder.patientInfo.crmBillingAddressTimeZone : this.salesOrder.crmDeliveryAddressTimeZone;
    this.appointmentService.searchFacilitybyId(facilitySearchRequest)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result) => {
        if (result.isSuccess) {
          if (result.responseModel != undefined && result.responseModel != null) {
            var facilities = result.responseModel;
            if (facilities && facilities.length > 0) {

              this.router.navigate(['/admin/book-appointment/confirm-date-time-slot/' + this.appointment.crmSalesorderId + '/' + this.appointment.appointmentDetailInfo.crmFacilityId]);
            }
            else {
              this.SchedulePopup = true;
              this.showWarningMessage('Facility not available for book appointment.');
            }
          }
        }
      });
  }

  ViewSalesOrder() {
    this.router.navigate(['/admin/appointments/salesorders/detail/', this.salesOrderId], { state: { searchRequestModel: this.searchRequestModel, selectedTab: this.index, isBookAppintment: this.isAppointmentDisabled, selectedfilterIndex: this.selectedfilterIndex } });
  }

  //End : Non Scheduled Events

  filterShowHide: boolean = false;
  filterShowHideSchedule: boolean = false;
  filterShowHideEvent() {
    this.filterShowHide = !this.filterShowHide;
    if (this.filterShowHide) {
      this.height = "450px";
    }
    else {
      this.height = "400px";
    }
    //if (this.filterShowHide == false)
    //  this.clearSalesOrderFilters();
  }


  public clearSalesOrderFilters() {

    this.currentSelectedNSUserBranch = this.currentUserBranch;
    this.searchRequestModel.crmBranchId = this.currentSelectedNSUserBranch;
    this.NSSelectedDateRange = null;


    let selectedBranch = this.branchResponseModel.find(x => x.crmBranchId == this.currentSelectedNSUserBranch);
    if (selectedBranch) {
      this.selectedNSbranch = selectedBranch;

    }
    else {
      this.selectedNSbranch = this.branchResponseModel[0];

    }


    this.searchRequestModel.dictionaryFilter = {}
    this.searchRequestModel.dictionaryFilter['SearchText'] = this.searchBox.nativeElement.value;
    let selSatatus = this.salesSelectedOrderCountModels;
    if (selSatatus) {
      if (selSatatus.salesOrderStatus.toUpperCase() == "TELEHEALTHREQUEST") {
        this.searchRequestModel.dictionaryFilter['Telehealth'] = 'true';
      }
      else if (selSatatus.salesOrderStatus.toUpperCase() == "CLINICAPPOINTMENTREQUEST") {
        this.searchRequestModel.dictionaryFilter['ClinicAppointmentCallback'] = 'true';
      }
      else
        this.searchRequestModel.dictionaryFilter['SalesOrdeStatus'] = selSatatus.salesOrderStatusDisplayble;
    }

    this.resetPageIndex();
    this.getsalesorders();


  };


  AppointmentBookingPopup: boolean = false;
  ReassignAppointmentDialog() {
    this.AppointmentBookingPopup = true;
  }
  EmailEditStatus: boolean = false;
  PhoneEditStatus: boolean = false;
  patientEmail: string = "";
  patientPhone: string = "";

  EditEamil() {
    this.EmailEditStatus = !this.EmailEditStatus;
  }

  EditPhone() {
    this.PhoneEditStatus = !this.PhoneEditStatus;
  }

  cancelEmail() { this.EmailEditStatus = !this.EmailEditStatus; }
  cancelPhone() { this.PhoneEditStatus = !this.PhoneEditStatus; }

  indexActionTab: number = 0;

  showDialog(crmSalesOrderId, appointmentId) {

    if (!this.checkCall()) {
      this.showWarningMessage('Only one patient can be called at one time.');
      return;
    }
    this.schAppointmentId = appointmentId;
    this.salesOrderId = crmSalesOrderId;
    this.isAppointment = this.schAppointmentId > 0 ? true : false;
    this.indexActionTab = 0;
    this.scheduleActionePopUp = this.schAppointmentId > 0 ? 'Reschedule' : 'Schedule';

    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true,
      closable: true,
      styleClass: 'book-appt-popup-outer',
      data: {
        crmSalesOrderId: crmSalesOrderId,
        isRescheduledRequest: this.schAppointmentId > 0,
        isScheduleOrder: true,
        isAppointment: false,
        schAppointmentId: this.schAppointmentId,
        isVoidOrder: false,
        isCancelOrder: false,
        isCall: false,
        voidFrom: this.voidFrom ? "P" : this.voidFrom,
        defaultModeofAppointment: this.defaultModeofAppointment
      },
    });

    ref.onClose.subscribe(() => {
      this.getsalesorders();
      this.HangUpCall();
    });
  }

  updateVoidSalesOrder() {

    let appointmentRequestBT = new BTSalesOrderUpdateRequestModel();
    appointmentRequestBT.CrmModifiedBy = this.loggedInUserId;
    appointmentRequestBT.IsUpdateToBrightree = true;
    appointmentRequestBT.IsDeliveryNoteOverride = true;
    appointmentRequestBT.IsOrderNoteOverride = true;
    appointmentRequestBT.OrderNote = null;
    appointmentRequestBT.DeliveryNote = null;
    appointmentRequestBT.PractitionerName = null;
    appointmentRequestBT.PractitionerId = 0;
    appointmentRequestBT.ScheduledDeliveryStartDateString = null;
    appointmentRequestBT.ScheduledDeliveryStartTimeString = null;
    appointmentRequestBT.ScheduledDeliveryStartDate = null;
    appointmentRequestBT.WIPDateNeededString = moment().toDate().toDateString();
    appointmentRequestBT.WIPDateNeeded = moment().toDate();
    let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void')
    if (selectedWipStaus) {
      appointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
      appointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
      appointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
    }
    let cancelRequestModel: AppointmentCancelRequest[] = new Array();
    if (this.selectedsalesOrders != undefined && this.selectedsalesOrders != null) {
      this.selectedsalesOrders.forEach(value => {
        //console.log(value.schAppointmentId);
        let appointmentCancelRequestModel = new AppointmentCancelRequest();
        appointmentCancelRequestModel.crmSalesOrderId = value.crmSalesOrderId;
        appointmentCancelRequestModel.schAppointmentId = value.isScheduled && Number(value.schAppointmentId) > 0 ? value.schAppointmentId : 0;
        appointmentCancelRequestModel.salesOrderUpdateRequestModelBT = appointmentRequestBT;
        appointmentCancelRequestModel.modifiedByUserInfoId = this.loggedInUserId;

        cancelRequestModel.push(appointmentCancelRequestModel);

      });
      this.dialougeService.open(ConfirmDialogComponent, {
        data:
        {
          message: 'Are you sure you want to void appointment ?',
        },
        header: 'Confirmation'
      }).onClose.subscribe((response: boolean) => {
        if (!response) {
          return;
        }

        this.loading = true;


        this.appointmentService.VoidUpdateSalesOrders(cancelRequestModel)
          .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
          .subscribe((result: ResultOfT<boolean>) => {
            this.processResult<boolean>(result, () => {
              this.showSuccessMessage('Appointment has been voided successfully.');
              this.selectedsalesOrders = [];
              if (this.selectedsalesOrders.length > 0)
                this.isDisabled = false;
              else
                this.isBulkRefreshed = this.isDisabled = true;
              this.resetPageIndex();
              this.getsalesorders();
              this._cdr.detectChanges();
            });

          }, (httpResponseError) => {
            this.showErrorMessage(httpResponseError.message);
          });
      });
    } else {
      this.showWarningMessage('Please select saleorder(s)');
      return;
    }

  }

  showVoidSalesOrderDialog(crmSalesOrderId, appointmentId) {
    if (!this.checkCall()) {
      this.showWarningMessage('Only one patient can be called at one time.');
      return;
    }
    this.salesOrderId = crmSalesOrderId;
    this.isAppointment = appointmentId > 0;
    this.schAppointmentId = appointmentId;
    this.indexActionTab = 0;
    this.scheduleActionePopUp = appointmentId > 0 ? 'Reschedule' : 'Schedule';
    //this.getSalesOrderInfo(this.salesOrderId);

    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true,
      closable: true,
      styleClass: 'book-appt-popup-outer',
      data: {
        crmSalesOrderId: crmSalesOrderId,
        isRescheduledRequest: appointmentId > 0,
        isScheduleOrder: false,
        isAppointment: false,
        schAppointmentId: 0,
        isVoidOrder: true,
        isCancelOrder: false,
        isCall: false,
        voidFrom: this.voidFrom ? "P" : this.voidFrom,
        defaultModeofAppointment: this.defaultModeofAppointment
      },
    });

    ref.onClose.subscribe(() => {

      if (this.index == 0) {
        this.getsalesorders();
      }
      this.HangUpCall();

    });

  }

  get fVoid() { return (<UntypedFormGroup>this.form.get('formVoidAppointment')).controls; }

  get formVoidAppointment() {
    return this.form.get('formVoidAppointment');
  }

  private getValuesFromVoidForm(): AppointmentCancelRequest {
    const form = this.formVoidAppointment;
    const cancelRequestModel = new AppointmentCancelRequest();
    var reason = form.get(this.formFields.voidReason).value;
    cancelRequestModel.schCancelReason = reason.salesOrderVoidReason;
    cancelRequestModel.schComments = form.get(this.formFields.voidReasonComments).value;
    return cancelRequestModel;
  }

  private getValuesFromUpdateStautsForm(): AppointmentCancelRequest {
    const cancelRequestModel = new AppointmentCancelRequest();
    cancelRequestModel.schCancelReason = this.updateStatusforminfo?.reason;
    cancelRequestModel.schComments = this.updateStatusforminfo?.reasonComment;
    return cancelRequestModel;
  }

  async getCancelVoidReasons() {

    this.loading = true;
    this.settingsService.getCancelVoidReasons()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          if (result && result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.reasonsResponseModel = result.responseModel;
              const myClonedArray = [];
              this.reasonsResponseModel.forEach(val => myClonedArray.push(Object.assign({}, val)));
              this.voidReasonsResponseModel = myClonedArray.filter(x => x.salesOrderReasonType === 'Void');
            }
          }
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });

  }

  formFields = {
    voidReason: 'voidReason',
    voidReasonComments: 'voidReasonComments',
  };

  validationMessages = {
    voidReason: {
      required: 'Void reason is required',
    },
    voidReasonComments: {
      required: 'Comment is required',
    },
  };


  private buildForm() {

    const formVoidGroup = this.formBuilder.group({});

    // tslint:disable-next-line: max-line-length
    formVoidGroup.addControl(this.formFields.voidReason, this.formBuilder.control('', { validators: [Validators.required], updateOn: Constants.formControlUpdateStrategy.blur }));
    // tslint:disable-next-line: max-line-length
    formVoidGroup.addControl(this.formFields.voidReasonComments, this.formBuilder.control('', { validators: [Validators.required], updateOn: Constants.formControlUpdateStrategy.blur }));


    this.form = this.formBuilder.group({
      formVoidAppointment: formVoidGroup
    });
  }

  cancelVoidAppointment() {
    const form = this.formVoidAppointment;
    //form.get(this.formFields.deviceName).setValue(this.selectedDeviceModel.deviceName);
    form.get(this.formFields.voidReason).setValue('');
    form.get(this.formFields.voidReasonComments).setValue('');
    form.reset();
    this.isBrightreeSystemAppUpdate = !this.isBrightreeSystemAppUpdateSetting;
    this.displayVoidAppointment = false;
  }

  voidAppointment() {


    if (this.salesOrderAppIds != null && this.salesOrderAppIds.length > 0) {
      this.formVoidAppointmentSubmitted = true;
      /* if (this.formVoidAppointment.invalid) {
        this.markFormAsTouched();
        return;
      } */
      this.formVoidAppointmentSubmitted = false;
      this.CancelVoidSaleOrderSubmit();
      return;
    }
    //this code for bulk cancel/void //

    this.formVoidAppointmentSubmitted = true;
    if (this.formVoidAppointment.invalid) {
      this.markFormAsTouched();
      return;
    }
    this.formVoidAppointmentSubmitted = true;

    if (this.formVoidAppointment.invalid) {
      this.markFormAsTouched();
      return;
    }
    this.formVoidAppointmentSubmitted = false;
    const cancelRequestModel = this.getValuesFromUpdateStautsForm(); //this.getValuesFromVoidForm();
    cancelRequestModel.modifiedByUserInfoId = this.loggedInUserId;
    cancelRequestModel.schAppointmentId = this.isRescheduledRequest ? this.voidschAppointmentId : this.voidSalesOrderId;
    cancelRequestModel.voidFrom = this.voidFrom == "A" ? this.voidFrom : "P";

    let voidAppointmentRequestBT = new BTSalesOrderUpdateRequestModel();
    voidAppointmentRequestBT.IsUpdateToBrightree = false;
    voidAppointmentRequestBT.IsDeliveryNoteOverride = true;
    voidAppointmentRequestBT.IsOrderNoteOverride = true;
    voidAppointmentRequestBT.OrderNote = null;
    voidAppointmentRequestBT.DeliveryNote = null;
    voidAppointmentRequestBT.PractitionerName = null;
    voidAppointmentRequestBT.PractitionerId = 0;
    voidAppointmentRequestBT.ScheduledDeliveryStartDateString = null;
    voidAppointmentRequestBT.ScheduledDeliveryStartTimeString = null;
    voidAppointmentRequestBT.ScheduledDeliveryStartDate = null;
    voidAppointmentRequestBT.WIPDateNeededString = moment().toDate().toDateString();
    voidAppointmentRequestBT.WIPDateNeeded = moment().toDate();
    if (cancelRequestModel.voidFrom === 'P') {

      let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void')
      if (selectedWipStaus) {
        voidAppointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
        voidAppointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
        voidAppointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
        voidAppointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
      }
    }
    else {
      let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'voidreview')
      if (selectedWipStaus) {
        voidAppointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
        voidAppointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
        voidAppointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
        voidAppointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
      }
    }
    this.isBrightreeSystemAppUpdate = this.updateStatusforminfo?.isBrightreeSystemAppUpdate;
    voidAppointmentRequestBT.IsUpdateToBrightree = !this.isBrightreeSystemAppUpdate;
    cancelRequestModel.salesOrderUpdateRequestModelBT = voidAppointmentRequestBT;
    let appointmentRequest = this.isRescheduledRequest ? this.appointmentService.VoidAppointment(cancelRequestModel) : this.appointmentService.VoidSalesOrder(cancelRequestModel);
    //this.appointmentService.CancelAppointment(cancelRequestModel)
    this.loading = true;
    appointmentRequest.pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result) => {
        if (result.isSuccess) {
          if (result.responseModel) {
            this.showSuccessMessage("Appointment has been voided");
            const form = this.formVoidAppointment;
            //form.get(this.formFields.deviceName).setValue(this.selectedDeviceModel.deviceName);
            form.get(this.formFields.voidReason).setValue('');
            form.get(this.formFields.voidReasonComments).setValue('');
            form.reset();
            this.selectedsalesOrders = [];
            if (this.selectedsalesOrders.length > 0)
              this.isDisabled = false;
            else
              this.isBulkRefreshed = this.isDisabled = true;
            this.resetPageIndex();
            this.getsalesorders();

            this.voidschAppointmentId = null; this.voidSalesOrderId = null;
            this.displayVoidAppointment = false;
            this._cdr.detectChanges();
            this.loading = false
          }
        }
        else {
          this.loading = false
          if (result.message)
            this.showErrorMessage(result.message);
          else
            this.showErrorMessage("There was problem in cancelling your appointment.");
        }
      });

  }
  formVoidAppointmentSubmitted: boolean = false;
  displayVoidAppointment: boolean;
  cancelschAppointmentId: number;
  voidSalesOrderId: number;
  voidschAppointmentId: number;
  isRescheduledRequest: boolean;

  showVoidAppointment(schAppointmentId) {
    let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void')
    if (selectedWipStaus) {
      this.isBrightreeSystemAppUpdateSetting = selectedWipStaus.crmIsUpdateToBrigthree;
      this.isBrightreeSystemAppUpdate = !this.isBrightreeSystemAppUpdateSetting;
    }
    this.voidschAppointmentId = schAppointmentId;
    this.isRescheduledRequest = true;

    let action = 'Void';
    let popupHeader = 'Update Void Status of Appointment(s)';
    this.callUpdateStatusForm(action, popupHeader);
  }

    onBTSelect(status: any) {

    if (status.checked) {
      this.isBrightreeSystemAppUpdate = true;
    }
    else {
      this.isBrightreeSystemAppUpdate = false;
    }

  }

  showVoidSalesOrder(crmSalesOrderId) {
    let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void')
    if (selectedWipStaus) {
      this.isBrightreeSystemAppUpdateSetting = selectedWipStaus.crmIsUpdateToBrigthree;
      this.isBrightreeSystemAppUpdate = !this.isBrightreeSystemAppUpdateSetting;
    }
    this.voidSalesOrderId = crmSalesOrderId;
    this.isRescheduledRequest = false;
    //this.displayVoidAppointment = true;
    let action = 'Void';
    let popupHeader = 'Update Void Status of Appointment(s)';
    this.callUpdateStatusForm(action, popupHeader);
  }

  async HangUpCall() {
    if (this.device) {
      this.device.disconnectAll();
      this.isCallStarted = false;
    }
  }
  showCallSalesOrderDialog(crmSalesOrderId, appointmentId) {
    if (!this.checkCall()) {
      this.showWarningMessage('Only one patient can be called at one time.');
      return;
    }
    this.salesOrderId = crmSalesOrderId;
    this.isAppointment = appointmentId > 0;
    this.schAppointmentId = appointmentId;
    this.indexActionTab = 0;
    this.scheduleActionePopUp = appointmentId > 0 ? 'Reschedule' : 'Schedule';
    //this.getSalesOrderInfo(this.salesOrderId);

    const ref = this.dialougeService.open(BookAppointmentInfoComponent, {
      showHeader: true,
      closable: true,
      styleClass: 'book-appt-popup-outer',
      data: {
        crmSalesOrderId: crmSalesOrderId,
        isRescheduledRequest: appointmentId > 0,
        isScheduleOrder: false,
        isAppointment: false,
        schAppointmentId: 0,
        isVoidOrder: false,
        isCancelOrder: false,
        isCall: true,
        voidFrom: this.voidFrom ? "P" : this.voidFrom,
        defaultModeofAppointment: this.defaultModeofAppointment
      },
    });

    ref.onClose.subscribe(() => {

      if (this.index == 0) {
        //this.getSalesOrderCountByStatus();
        this.getsalesorders();
      }
      this.HangUpCall();

    });



  }

  checkCall(): boolean {
    let check = true;
    this.twillioCallService.twillioCall
    .pipe(takeUntil(this.unsubscriber),finalize(() => this.progress.next(false)))
    .subscribe((twillioObject: TwilioDeviceObject) => {

      if (twillioObject) {
        check = false;
      }
      else {
        check = true;
      }
    });
    return check;

  }

  ExportNoShowAppointments() {



    if (this.loading)
      this.loading = false;
    let schSalesOrderIds: any[];
    if (this.selectedsalesOrders != undefined && this.selectedsalesOrders.length > 0) {

      schSalesOrderIds = new Array()
      this.selectedsalesOrders.forEach(value => {
        schSalesOrderIds.push(value.crmSalesOrderAPPId.toString());
      })
    }
    if (schSalesOrderIds != undefined && schSalesOrderIds.length > 0) {
      if (schSalesOrderIds.length == 1) {
        this.searchRequestModel.dictionaryFilter['SelectedSchSalesOrderIds'] = schSalesOrderIds.toString();
      }
      else {
        this.searchRequestModel.dictionaryFilter['SelectedSchSalesOrderIds'] = schSalesOrderIds.toString();
      }
    }
    if(this.searchRequestModel.BookingSearchFromDate != undefined && this.searchRequestModel.BookingSearchFromDate !=null){
      let startDate = moment(this.searchRequestModel.BookingSearchFromDate).format("yyyy/MM/DD");
      let endDate = moment(this.searchRequestModel.BookingSearchFromDate).format("yyyy/MM/DD");
      this.searchRequestModel.BookingSearchFromDateString=startDate;
      this.searchRequestModel.BookingSearchToDateString=endDate;
    }
    this.loading = true;
    this._cdr.detectChanges();
    this.dataExpressionloading = true;
    this.appointmentService.ExportNoShowAppointments(this.searchRequestModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: Blob) => {
        const downloadedFile = new Blob([result], { type: result.type });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        a.download = 'NoShowAppointments.csv';
        //a.download = 'ExportData_' + '.csv';
        document.body.appendChild(a);
        a.target = '_blank';
        a.href = URL.createObjectURL(downloadedFile);
        document.body.removeChild(a);
        a.click();
      }, (httpResponseMessage) => {
        this.showErrorMessage(this.getErrorMessage(httpResponseMessage));
      });
  }

  onSOFilterSearch() {
    if (this.NSSelectedDateRange) {
      this.searchRequestModel.dictionaryFilter = {}
      this.searchRequestModel.dictionaryFilter['SearchText'] = this.searchBox.nativeElement.value;

      let selSatatus = this.salesSelectedOrderCountModels;
      if (selSatatus) {
        if (selSatatus.salesOrderStatus.toUpperCase() == "TELEHEALTHREQUEST") {
          this.searchRequestModel.dictionaryFilter['Telehealth'] = 'true';
        }
        else if (selSatatus.salesOrderStatus.toUpperCase() == "CLINICAPPOINTMENTREQUEST") {
          this.searchRequestModel.dictionaryFilter['ClinicAppointmentCallback'] = 'true';
        }
        else
          this.searchRequestModel.dictionaryFilter['SalesOrdeStatus'] = selSatatus.salesOrderStatusDisplayble;
      }

      if (this.selectedDoctorResponseModel != undefined) {
        if (this.selectedDoctorResponseModel.crmDoctorId > 0)
          this.searchRequestModel.dictionaryFilter['OrderingDoctor'] = this.selectedDoctorResponseModel.crmDoctorId.toString();
      }


      if (this.selectedfacilityResponseModel != undefined) {
        if (this.selectedfacilityResponseModel.crmFacilityId > 0)
          this.searchRequestModel.dictionaryFilter['OrderingDoctorFacility'] = this.selectedfacilityResponseModel.crmFacilityId.toString();
      }

      let startDate = this.NSSelectedDateRange.startDate.format("YYYY/MM/DD");
      let endDate = this.NSSelectedDateRange.endDate.format("YYYY/MM/DD");

      if (startDate && endDate) {
        startDate = moment(startDate).toDate();
        endDate = moment(endDate).toDate();
        if (startDate > endDate) {
          this.showWarningMessage("From Date should not be greater than To Date.");
          return;
        }
      }
      if (startDate && endDate) {
        this.searchRequestModel.dictionaryFilter['CustomDateFilter'] = 'CustomDate';
        this.searchRequestModel.searchFromDate = startDate;
        this.searchRequestModel.searchToDate = endDate;
      }
    }
    else {
      this.searchRequestModel.dictionaryFilter = {};
    }
    this.resetPageIndex();
    this.getsalesorders();
  }

  onClearSOFilterSearch() {
    this.searchRequestModel.dictionaryFilter['SearchText'] = this.searchBox.nativeElement.value = '';
    this.currentSelectedNSUserBranch = Number(0);
    this.searchRequestModel.crmBranchId = Number(0);
    this.selectedNSbranch = this.branchResponseModel[0];
    this.selectedTimeZone = new Array<TimeZoneAvailableResponseModel>();
    this.selectedPrimaryInsuranceProvider = new Array<PrimaryInsuranceProviderResponseModel>();;
    this.selectedDoctorResponseModel = new DoctorResponseModel();
    this.selectedfacilityResponseModel = new FacilityResponseModelDropdownList();
    this.searchRequestModel.selectedTimeZone = null;
    this.searchRequestModel.selectedPrimaryInsurance = null;
    this.NSSelectedDateRange = null;
    this.selectedClassificationType = new Array<FilterClassificationTypeResponseModel>();
    this.searchRequestModel.selectedClassificationType = null;
  }

  onDoctorChange(event) {
    if (event.value) {
      this.searchRequestModel.dictionaryFilter['OrderingDoctor'] = event.value.crmDoctorId.toString();
    }
  }

  onFacilityChange(event) {
    if (event.value) {
      this.searchRequestModel.dictionaryFilter['OrderingDoctorFacility'] = event.value.crmFacilityId.toString();
    }
  }

  private async getAllSalesOrderDoctors() {
    this.progress.next(true);
    await this.appointmentService.GetAllDoctors()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise().then((result) => {
        if (result.isSuccess) {
          if (result.responseModel != undefined && result.responseModel != null) {

            this.doctorResponseModel = result.responseModel;
          }
        }
      })
      .catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  private async getAllSalesOrderDoctorFacility() {
    this.progress.next(true);
    await this.appointmentService.GetAllDoctorFacility()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise().then((result) => {
        if (result.isSuccess) {
          if (result.responseModel != undefined && result.responseModel != null) {
            this.facilityResponseModelDropdownList = result.responseModel;
          }
        }

      })
      .catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  showVoidAppointmentA(schAppointmentId) {
    let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'voidreview')
    if (selectedWipStaus) {
      this.isBrightreeSystemAppUpdateSetting = selectedWipStaus.crmIsUpdateToBrigthree;
      this.isBrightreeSystemAppUpdate = !this.isBrightreeSystemAppUpdateSetting;
    }
    this.voidFrom = 'A';
    this.voidschAppointmentId = schAppointmentId;
    this.isRescheduledRequest = true;
    //this.displayVoidAppointment = true;
    let action = 'Void review';
    let popupHeader = 'Update Void Review Status of Appointment(s)';
    this.callUpdateStatusForm(action, popupHeader);

  }

  async Unlock(data: SalesOrderSummaryResponseModel, isOther: boolean) {
    if (!isOther) {
      this.dialougeService.open(ConfirmDialogComponent, {
        data:
        {
          message: 'Are you sure you want to unlock appointment ?',
        },
        header: 'Confirmation'
      }).onClose.subscribe((response: boolean) => {
        if (!response) {
          return;
          //this.selectedAppointmentOrderStatus = this.defaultselectedAppointmentOrderStatus;
        }
        this.progress.next(true);
        this.appointmentService.UnLockSalesOrder(data.schAppointmentCallListId)
          .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
          .toPromise()
          .then((result) => {
            this.processResult<boolean>(result, () => {
              this.showSuccessMessage('Sales order unlocked successfully.');
              data.schIsLocked = false;
              this.isRowDisabled(data);
              this.IsSalesOrdersLockedByUser();
            });
          }).catch((httpResponseError) => {
            this.showErrorMessage(httpResponseError.message);
          });
      });
    }
    else {
      this.progress.next(true);
      await this.appointmentService.UnLockSalesOrder(data.schAppointmentCallListId)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
        .toPromise()
        .then((result) => {
          this.processResult<boolean>(result, () => {
            this.showSuccessMessage('Sales order unlocked successfully.');
            data.schIsLocked = false;
            this.isRowDisabled(data);
            this.IsSalesOrdersLockedByUser();
          });
        }).catch((httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        });
    }
  }

  CancelVoidAllAppointmentS(type: string, isSaleOrder: boolean) {
    this.isSaleOrder = isSaleOrder;
    this.appointmentType = type;

    this.salesOrderAppIds = new Array()

    if (isSaleOrder) {
      this.salesOrderAppIds = this.selectedsalesOrders;
    }
    else {
      this.salesOrderAppIds = this.selectedAppointments;
    }

    if (!this.salesOrderAppIds || this.salesOrderAppIds.length <= 0) {
      if (isSaleOrder) {
        this.showWarningMessage('Please select sales order(s).');
      } else {
        this.showWarningMessage('Please select appointment(s).');
      }
      this._cdr.detectChanges();
      return;
    }
    let action = 'Void';
    let popupHeader = 'Update Void Status of Appointment(s)';
    this.isRescheduledRequest = false;
    if (type == "voidreview") {
      action = 'Void review';
      popupHeader = 'Update Void Review Status of Appointment(s)';
      let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'voidreview')
      if (selectedWipStaus) {
        this.isBrightreeSystemAppUpdateSetting = selectedWipStaus.crmIsUpdateToBrigthree;
        this.isBrightreeSystemAppUpdate = !this.isBrightreeSystemAppUpdateSetting;
      }
      this.displayCancelAppointment = false;
      this.displayVoidAppointment = true;
      this.voidFrom = 'A';
    }
    else if (type == "void") {
      let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void')
      if (selectedWipStaus) {
        this.isBrightreeSystemAppUpdateSetting = selectedWipStaus.crmIsUpdateToBrigthree;
        this.isBrightreeSystemAppUpdate = !this.isBrightreeSystemAppUpdateSetting;
      }
      this.displayCancelAppointment = false;
      this.displayVoidAppointment = true;
      this.voidFrom = 'P';
    }
    else {
      this.displayVoidAppointment = false;
      this.displayCancelAppointment = true;
    }

    if(this.displayVoidAppointment == true){
      this.displayVoidAppointment = false;
      this.callUpdateStatusForm(action, popupHeader);
    }

  }

  async SendVoiceMailSelectedSales(isSaleOrder: boolean) {
    this.isSaleOrder = isSaleOrder;
    this.salesOrderAppIds = new Array()

    if (isSaleOrder) {
      this.salesOrderAppIds = this.selectedsalesOrders;
    }
    else {
      this.salesOrderAppIds = this.selectedAppointments;
    }

    console.log(this.salesOrderAppIds);

    if (!this.salesOrderAppIds || this.salesOrderAppIds.length <= 0) {
      if (isSaleOrder) {
        this.showWarningMessage('Please select sales order(s).');
      }
      else {
        this.showWarningMessage('Please select appointment(s).');
      }
      this._cdr.detectChanges();
      return;
    }

    let salesorderIds = "";

    if (this.salesOrderAppIds.length > 0 && this.salesOrderAppIds != undefined) {
      this.salesOrderAppIds.forEach((value, index) => {
        let crmSalesOrderId = this.isSaleOrder ? (this.salesOrderAppIds[index]["crmSalesOrderId"]) : (this.salesOrderAppIds[index]["crmSalesorderId"]);
        if (salesorderIds != "") {
          salesorderIds = salesorderIds + "," + crmSalesOrderId
        }
        else {
          salesorderIds = crmSalesOrderId;
        }
      });

      await this.appointmentService.BulkSendVoiceMail(salesorderIds, this.loggedInUserId)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
        .toPromise().then((result) => {
          if (result.responseModel) {
            this.showSuccessMessage('Voice mail has been Sent to Patients.');
            // this.callPopup = false;
            this.isCallStarted = false;
            this.salesOrderAppIds = [];
            this.selectedsalesOrders = [];
            this.selectedAppointments = [];
            this._cdr.detectChanges();
          }
          else {
            this.showWarningMessage('Error occurred while sending voice mail.');
          }
        }).catch((httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        });
    }

  }

  CancelVoidSaleOrderSubmit() {

    let statusMessage = this.appointmentType == "voidreview" ? "voided for review" : this.appointmentType == "void" ? "voided" : "cancel";
    let statusType = this.isSaleOrder ? "saleorder(s) ?" : "appointment(s) ?";

    this.loading = true;
    const cancelRequestList = [];
    this.salesOrderAppIds.forEach((value, index) => {

      let cancelRequestModel = this.getValuesFromUpdateStautsForm();// this.getValuesFromVoidForm();
      cancelRequestModel.modifiedByUserInfoId = this.loggedInUserId;
      cancelRequestModel.schAppointmentId = this.salesOrderAppIds[index]["schAppointmentId"];
      cancelRequestModel.crmSalesOrderId = this.isSaleOrder ? (this.salesOrderAppIds[index]["crmSalesOrderId"]) : (this.salesOrderAppIds[index]["crmSalesorderId"]);
      cancelRequestModel.SalesOrderStatus = this.appointmentType == "voidreview" ? "VoidReview" : this.appointmentType == "void" ? "Void" : "Cancel";

      let voidAppointmentRequestBT = new BTSalesOrderUpdateRequestModel();
      voidAppointmentRequestBT.IsUpdateToBrightree = false;
      voidAppointmentRequestBT.IsDeliveryNoteOverride = true;
      voidAppointmentRequestBT.IsOrderNoteOverride = true;
      voidAppointmentRequestBT.OrderNote = null;
      voidAppointmentRequestBT.DeliveryNote = null;
      voidAppointmentRequestBT.PractitionerName = null;
      voidAppointmentRequestBT.PractitionerId = 0;
      voidAppointmentRequestBT.ScheduledDeliveryStartDateString = null;
      voidAppointmentRequestBT.ScheduledDeliveryStartTimeString = null;
      voidAppointmentRequestBT.ScheduledDeliveryStartDate = null;
      voidAppointmentRequestBT.WIPDateNeededString = moment().toDate().toDateString();
      voidAppointmentRequestBT.WIPDateNeeded = moment().toDate();

      if (this.appointmentType == "voidreview") {
        let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'voidreview')
        if (selectedWipStaus) {
          voidAppointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
          voidAppointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
          voidAppointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
          voidAppointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
        }
      } else if (this.appointmentType == "void") {
        let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void')
        if (selectedWipStaus) {
          voidAppointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
          voidAppointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
          voidAppointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
          voidAppointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
        }
      } else if (this.appointmentType == "cancel") {
        let selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'cancel')
        if (selectedWipStaus) {
          voidAppointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
          voidAppointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
          voidAppointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
          voidAppointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
        }
      }
      this.isBrightreeSystemAppUpdate = this.updateStatusforminfo?.isBrightreeSystemAppUpdate;
      voidAppointmentRequestBT.IsUpdateToBrightree = !this.isBrightreeSystemAppUpdate;
      cancelRequestModel.salesOrderUpdateRequestModelBT = voidAppointmentRequestBT;
      cancelRequestList.push(cancelRequestModel);
    });

    if (this.salesOrderAppIds != null && this.salesOrderAppIds.length > 0) {
      let appointmentRequest = this.appointmentService.UpdateSalesOrderByWipStatus(cancelRequestList);
      appointmentRequest.pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
        .subscribe((result) => {
          if (result.isSuccess) {

            const formvoid = this.formVoidAppointment;
            formvoid.get(this.formFields.voidReason).setValue('');
            formvoid.get(this.formFields.voidReasonComments).setValue('');
            formvoid.reset();

            // const formcan = this.formCancel;
            // formcan.get(this.formFields.reason).setValue('');
            // formcan.get(this.formFields.reasonComments).setValue('');
            // formcan.reset();
            this.displayCancelAppointment = false;
            this.displayVoidAppointment = false;

            this.salesOrderAppIds = [];
            this.selectedsalesOrders = [];
            this.selectedAppointments = [];

            this.showSuccessMessage("Appointments has been " + statusMessage);
            this.getsalesorders();
            this._cdr.detectChanges();
            this.loading = false

          }
          else {
            this.loading = false
            if (result.message)
              this.showErrorMessage(result.message);
            else
              this.showErrorMessage("There was problem in cancelling your appointment.");
          }
        });
    }
  }

  private async getAllPrimaryInsuranceProviders() {
    await this.appointmentService.GetAllPrimaryInsuranceProviders('No Show', this.loggedInUserId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise()
      .then((result) => {
        this.processResult<PrimaryInsuranceProviderResponseModel[]>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.primaryInsuranceProviderList = result.responseModel;
            }
          }
        });
      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  ConfirmInvitePatientsCancel() {
    this.ConfirmInvitePatients = false;
  }

  SendInvitationforAppointment() {
    if (!this.selectedsalesOrders || this.selectedsalesOrders.length <= 0) {
      this.showWarningMessage('Please select sales order(s) to send an invitation.');
      this._cdr.detectChanges();
      return;
    }

    this.ConfirmInvitePatients = true;
    this.salesOrderIdToSendInvite = new Array()
    this.totalSelectedSendInviteSalesOrderIds = this.selectedsalesOrders.length;
    this.restrictedSalesOrderIdToSendInvite = [];
    this.selectedsalesOrders.forEach(value => {
      if (value.crmBranchIsAllowSelfScheduleAppointments) {
        this.salesOrderIdToSendInvite.push(value.crmSalesOrderId.toString());
      }
      else {
        this.restrictedSalesOrderIdToSendInvite.push(value);
      }
    });
  }

  ConfirmSendInvitePatients() {
    this.loading = true;
    this.appointmentService.SendInvitationForNotScheduled(this.salesOrderIdToSendInvite, this.loggedInUserId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<boolean>) => {
        this.processResult<boolean>(result, () => {
          this.showSuccessMessage('Invitation for appointment booking has been sent.');
          this.selectedsalesOrders = [];
          this.selectedAppointments = [];
          this._cdr.detectChanges();
        });

      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
    this.ConfirmInvitePatients = false;
  }

  onTimeZoneChange(event) {
    let timeZones = new Array<string>();
    if (event !== undefined && event != null) {
      this.selectedTimeZone.forEach((value: TimeZoneAvailableResponseModel) => {
        timeZones.push(value.appTimeZoneOffSet);
      });
      let arrayTimeZone = timeZones.join();
      this.searchRequestModel.selectedTimeZone = arrayTimeZone;
    }
  }

  onPrimaryInsurationProviderChange(event) {
    let primaryInsuranceProvider = new Array<string>();
    if (event !== undefined && event != null) {
      this.selectedPrimaryInsuranceProvider.forEach((value: PrimaryInsuranceProviderResponseModel) => {
        primaryInsuranceProvider.push(value.crmPolicyHolderName);
      });
      let arrayprimaryInsuranceProvider = primaryInsuranceProvider.join();
      this.searchRequestModel.selectedPrimaryInsurance = arrayprimaryInsuranceProvider;
    }
  }

  onPageChange(event) {

    if (event.value) {
      this.selectedpage = this.pageSiges.find(x => x.code == event.value.code);
      this.searchRequestModel.PageSize = Number(this.selectedpage.code);
      //this.searchRequestModel.dictionaryFilter = {}
      this.searchRequestModel.dictionaryFilter['SearchText'] = this.searchBox.nativeElement.value;
      let selSatatus = this.salesSelectedOrderCountModels;
      if (selSatatus) {
        if (selSatatus.salesOrderStatus.toUpperCase() == "TELEHEALTHREQUEST") {
          this.searchRequestModel.dictionaryFilter['Telehealth'] = 'true';
        }
        else if (selSatatus.salesOrderStatus.toUpperCase() == "CLINICAPPOINTMENTREQUEST") {
          this.searchRequestModel.dictionaryFilter['ClinicAppointmentCallback'] = 'true';
        }
        else
          this.searchRequestModel.dictionaryFilter['SalesOrdeStatus'] = selSatatus.salesOrderStatusDisplayble;
      }
      if (this.selectedDoctorResponseModel.crmDoctorId > 0)
        this.searchRequestModel.dictionaryFilter['OrderingDoctor'] = this.selectedDoctorResponseModel.crmDoctorId.toString();


      if (this.selectedfacilityResponseModel.crmFacilityId > 0)
        this.searchRequestModel.dictionaryFilter['OrderingDoctorFacility'] = this.selectedfacilityResponseModel.crmFacilityId.toString();

      let startDate = this.NSSelectedDateRange.startDate.format("YYYY/MM/DD");
      let endDate = this.NSSelectedDateRange.endDate.format("YYYY/MM/DD");

      if (startDate && endDate) {
        startDate = moment(startDate).toDate();
        endDate = moment(endDate).toDate();
        if (startDate > endDate) {
          this.showWarningMessage("From Date should not be greater than To Date.");
          return;
        }
      }
      if (startDate && endDate) {
        this.searchRequestModel.dictionaryFilter['CustomDateFilter'] = 'CustomDate';
        this.searchRequestModel.searchFromDate = startDate;
        this.searchRequestModel.searchToDate = endDate;
      }

      this.resetPageIndex();
      this.getsalesorders();
    }

  }

  private async getUserPreferenceColumn() {
    this.loading = true;

    await this.appointmentService.getUserPreferenceMasterColumn(ModuleType.NoShow, this.loggedInUserId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .toPromise().then((result) => {
        if (result.isSuccess) {
          if (result.responseModel != undefined && result.responseModel != null) {
            this.userPreferenceColumn = [];
            this.userPreferenceColumn = result.responseModel;
            this.userPreferenceColumn.forEach(x => {
              x.preferenceVisible = x.visible;
            })
            let IsAnyColVisible = this.userPreferenceColumn.filter(x => x.visible === true);
            if (IsAnyColVisible.length == 0) {
              this.isOnlyFixedColumnVisible = true;
            }
            else {
              this.isOnlyFixedColumnVisible = false;
            }
          }
        }

      })
      .catch((httpResponseError) => {
        this.loading = false
        this.showErrorMessage(httpResponseError.message);
      });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.userPreferenceColumn, event.previousIndex, event.currentIndex);
  }
  CancelNonSColumn(event, element) {
    element.hide(event);
    this.getUserPreferenceColumn();
  }

  onClassificationTypeChange(event) {
    let classificationType = new Array<number>();
    if (event !== undefined && event != null) {
      this.selectedClassificationType.forEach((value: FilterClassificationTypeResponseModel) => {
        classificationType.push(value.crmClassificationTypeId);
      });
      let arrayClassificationType = classificationType.join();
      this.searchRequestModel.selectedClassificationType = arrayClassificationType;

    }
  }
  private async getAllClassificationType() {
    await this.appointmentService.GetAllClassificationType()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise()
      .then((result) => {
        this.processResult<FilterClassificationTypeResponseModel[]>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.filterClassificationList = result.responseModel;
            }
          }
        });
      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  checkSelectedRecord(){
    this.isMultiSelected = 'False';
    if ( (this.selectedsalesOrders != undefined && this.selectedsalesOrders.length > 1)  ||
        (this.selectedAppointments != undefined && this.selectedAppointments.length > 1)){
     this.isMultiSelected = 'True';
    }
  }
  callUpdateStatusForm(action:string, header:string) {
    this.checkSelectedRecord();
    this.dialougeService.open(UpdateStatusOfAppointmentComponent, {
      data:{
        action: action,
        popupHeader: header,
        updateButtonText: 'Yes, Update',
        cancelButtonText: 'No, Cancel',
        reasonsResponseModel: this.voidReasonsResponseModel,
        isMultiSelected: this.isMultiSelected,
        isBrightreeSystemAppUpdate: this.isBrightreeSystemAppUpdate,
      },
    }).onClose.subscribe((response: any) => {

      if (response.action == 'Confirm') {
        this.updateStatusforminfo  = response;
        this.voidAppointment();
      }
      if (response.action == 'Cancel') {
        this.cancelVoidAppointment();
      }
    });
    /** End Code */
  }

}
